let dbInterval = null;

window.setDivideBuyPrice = variantPrice => {
  try {
    clearInterval(dbInterval);
    if (window.DivideBuy?.render) {
      let i = 0;
      dbInterval = setInterval(() => {
        i++;
        if (i >= 10) clearInterval(dbInterval);
        window.DivideBuy.render({ orderAmount: variantPrice });
      }, 10);
      window.DivideBuy.render({ orderAmount: variantPrice });
    } else {
      window.addEventListener('load', e => {
        if (window.DivideBuy) {
          window.DivideBuy.render({ orderAmount: variantPrice });
        }
      });
    }
  } catch (e) {
    console.error(e);
  }
};

// const lazyLoadImg = new LazyLoad({
//   elements_selector: 'img:not(.no-lazy):not(.shogun-image)'
// });

// document.addEventListener('DOMContentLoaded', () => {
//   if (location.href.includes('/blogs/blog/')) {
//     document.querySelectorAll('img').forEach(img => {
//       img.setAttribute('data-src', img.getAttribute('src'));
//       lazyLoadImg.update();
//       img.removeAttribute('src');
//     });
//   }
// });

window.getUrlParameter = function (sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};

window.getCookie = function (name) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length == 2) return parts.pop().split(';').shift();
};

window.setCookie = function (cname, cvalue, exMins) {
  var d = new Date();
  d.setTime(d.getTime() + exMins * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

String.prototype.number = function () {
  return this.replace(/[^\d.-]/g, '');
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN'
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', event => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', event => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(video => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach(video => video.pause());
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(button =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    const overlay = document.querySelector('.header__background-overlay');

    this.addAccessibilityAttributes(summaryElements);

    this.addEventListener('hover', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button').forEach(button =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    }
    // else {
    //   // trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

    //   // setTimeout(() => {
    //   //   detailsElement.classList.add('menu-opening');
    //   // });
    // }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      // this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      overlay.style.opacity = '0';
      overlay.style.visibility = 'hidden';
      if (document.querySelector('#dixa-iframe-wrapper')) {
        document.querySelector('#dixa-iframe-wrapper').classList.remove('hidden');
      }
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.shopify-section-group-header-group');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    if (summaryElement.classList.contains('header__icon--summary')) {
      overlay.style.opacity = '1';
      overlay.style.visibility = 'visible';
      overlay.addEventListener('onTouchMove', e => e.preventDefault());
      if (document.querySelector('#dixa-iframe-wrapper')) {
        document.querySelector('#dixa-iframe-wrapper').classList.add('hidden');
      }
      document.querySelector('.menu-drawer__wixa-link').addEventListener('click', e => {
        if (document.querySelector('#dixa-iframe-wrapper')) {
          document.querySelector('#dixa-iframe-wrapper').classList.remove('hidden');
        }
      });

      // document.querySelector('#dixa-iframe-wrapper').addEventListener('onTouchMove', e => e.preventDefault());
    }
  }
}
customElements.define('header-drawer', HeaderDrawer);

// function iOS_version() {
//   if(navigator.userAgent.match(/ipad|iphone|ipod/i)){ //if the current device is an iDevice
//   var ios_info ={};
//   ios_info.User_Agent=navigator.userAgent;
//   ios_info.As_Reported=(navigator.userAgent).match(/OS (\d)?\d_\d(_\d)?/i)[0];
//   ios_info.Major_Release=(navigator.userAgent).match(/OS (\d)?\d_\d(_\d)?/i)[0].split('_')[0];
//   ios_info.Full_Release=(navigator.userAgent).match(/OS (\d)?\d_\d(_\d)?/i)[0].replace(/_/g,".");
//   ios_info.Major_Release_Numeric=+(navigator.userAgent).match(/OS (\d)?\d_\d(_\d)?/i)[0].split('_')[0].replace("OS ","");
//   ios_info.Full_Release_Numeric=+(navigator.userAgent).match(/OS (\d)?\d_\d(_\d)?/i)[0].replace("_",".").replace("_","").replace("OS ","");   //converts versions like 4.3.3 to numeric value 4.33 for ease of numeric comparisons
//   return(ios_info);
//   }
// }

// var iOS=iOS_version();

let Accordions = [];
class Accordion {
  constructor(el) {
    // if (iOS.Major_Release_Numeric >= 12 || !/iP(hone|od|ad)/.test(navigator.platform)) {
    // Store the <details> element
    this.el = el;
    // Store the <summary> element
    this.summary = el.querySelector('summary');
    // Store the <div class="accordion__content"> element
    this.content = el.querySelector('.accordion__content');
    // Store the <div class="accordion__container"> element
    this.container = el.closest('.accordion__container');

    this.duration = 400;
    // Store the animation object (so we can cancel it if needed)
    this.animation = null;
    // Store if the element is closing
    this.isClosing = false;
    // Store if the element is expanding
    this.isExpanding = false;
    // Detect user clicks on the summary element
    this.summary.addEventListener('click', e => this.onClick(e));

    Accordions.push(this);
    // }
  }

  onClick(e) {
    // Stop default behaviour from the browser
    e.preventDefault();
    // Add an overflow on the <details> to avoid content overflowing
    this.el.style.overflow = 'hidden';
    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.el.open) {
      this.shrinkNeighbor();
      this.open();
      // Check if the element is being openned or is already open
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    // Set the element as "being closed"
    this.isClosing = true;

    // Store the current height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the height of the summary
    const endHeight = `${this.summary.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      },
      {
        duration: this.duration,
        easing: 'ease-out'
      }
    );

    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false);
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    // Apply a fixed height on the element
    this.el.style.height = `${this.el.offsetHeight}px`;
    // Force the [open] attribute on the details element
    this.el.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true;
    // Get the current fixed height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the open height of the element (summary height + content height)
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation

    this.animation = this.el.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      },
      {
        duration: this.duration,
        easing: 'ease-out'
      }
    );
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    this.el.open = open;
    // Clear the stored animation
    this.animation = null;
    // Reset isClosing & isExpanding
    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.el.style.height = this.el.style.overflow = '';
  }

  shrinkNeighbor() {
    Accordions.forEach(accordion => {
      if (accordion.container == this.container && accordion.el.open) {
        accordion.el.style.overflow = 'hidden';
        accordion.shrink();
      }
    });
  }
}

document.querySelectorAll('.accordion__animate').forEach(el => {
  new Accordion(el);
});

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this));
    this.addEventListener('keyup', event => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', event => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model'))
          this.hide();
      });
    } else {
      this.addEventListener('click', event => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', e => {
      e.stopPropagation();
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    // window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
      const src = this.querySelector('iframe').getAttribute('src');
      this.querySelector('iframe').setAttribute(
        'src',
        `${src}?autoplay=1&loop=1&autopause=0&muted=1`
      );
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    document.addEventListener('slider-update', cart => {
      this.update.bind(this);
    });
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(
      element => element.clientWidth > 0
    );
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollToCustom({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', e => {
      if (e.target.name != 'quantity') {
        this.onVariantChange();
      }
    });
    document.addEventListener('pageUpdated', e => {
      this.onVariantChange();
    });
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateStockIndicator();
    if (!this.currentVariant || !this.currentVariant.available) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.toggleAddButton(false, '', false);
    }
    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    if (typeof window.updateCompareTable === 'function') window.updateCompareTable();
  }

  hideSuggestionBundles() {
    if (document.querySelector('.suggested__bundles')) {
      document.querySelector('.suggested__bundles').classList.add('hidden');
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select:not(#quantity)'),
      select => select.value
    );
  }

  /**
   * Updates the current variant based on selected options.
   * Searches through variant data to find a variant that matches all currently selected options.
   * If no matching variant is found, defaults to the first variant in the array.
   */
  updateMasterId() {
    this.currentVariant =
      this.getVariantData().find(variant => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      }) || this.getVariantData()[0];
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.querySelector('li.product__media-item').scrollIntoView({ behavior: 'smooth' });
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;

    let utmCampaign;
    try {
      utmCampaign = decodeURIComponent(getUrlParameter('utm_campaign'));
    } catch (e) {}
    let mtsParameter;
    try {
      mtsParameter = decodeURIComponent(getUrlParameter('mts'));
    } catch (e) {}
    let params = new URLSearchParams(location.search);
    params.set('variant', this.currentVariant.id);
    window.history.replaceState(null, null, `?${params.toString()}`);
  }

  updateVariantInput() {
    let productFormId;
    this.dataset.productId
      ? (productFormId = `#product-form-${this.dataset.productId}`)
      : (productFormId = `#product-form-${this.dataset.section}`);
    const productForms = document.querySelectorAll(`${productFormId}, #product-form-installment`);
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then(response => response.text())
      .then(responseText => {
        let id;
        this.dataset.productId
          ? (id = `price-${this.dataset.productId}`)
          : (id = `price-${this.dataset.section}`);

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        //this.checkCoupon(destination)
      })
      .catch(err => {
        console.error(err);
      });
  }

  checkCoupon(element) {
    /*
    let parent = element.closest('.frequently-purchased__product-wrapper');
    if(parent && parent.getAttribute('data-type') && parent.getAttribute('data-type') == 'Mattress'){
      let priceWrapper = parent.querySelector('.frequently-purchased__price-wrapper');
      let originalPrice = priceWrapper.querySelector('.price-item.price-item--regular').textContent.number();
      let itemDiscount = 0;
      if(!coupons?.applied.exceptions || !coupons?.applied.exceptions.includes(parent.dataset.handle)){
        if(coupons?.applied.type == "percentage"){
          itemDiscount = originalPrice * coupons?.applied.value/100;
        }else if(coupons?.applied.type == "unit"){
          itemDiscount = coupons?.applied.value;
        }
      }
      let itemFinalPrice = (+originalPrice - itemDiscount).toLocaleString('en-GB');
      priceWrapper.innerHTML =`
        <div class="price price--regular price--on-sale ">
        <dl><div class="price__regular">
            <dt>
              <span class="visually-hidden visually-hidden--inline">Regular price</span>
            </dt>
            <dd class="price__last">
              <span class="price-item price-item--regular">
                £${itemFinalPrice}
              </span>
            </dd>
          </div>
          <div class="price__sale">
            <dt>
              <span class="visually-hidden visually-hidden--inline">Sale price</span>
            </dt>
            <dd class="price__last">
              <span class="price-item price-item--sale">
                £${itemFinalPrice}
              </span>
            </dd>
            ${+originalPrice.number() > +itemFinalPrice.number() ? `
              <dt class="price__compare">
                <span class="visually-hidden visually-hidden--inline">Regular price</span>
              </dt>
              <dd class="price__compare">
                <s class="price-item price-item--regular">£${originalPrice}

                </s>
              </dd>` :
            ''}
          </div>
          <small class="unit-price caption hidden">
            <dt class="visually-hidden">Unit price</dt>
            <dd class="price__last">
              <span></span>
              <span aria-hidden="true">/</span>
              <span class="visually-hidden">&nbsp;per&nbsp;</span>
              <span>
              </span>
            </dd>
          </small>
        </dl></div>
      `
    }
      */
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    let productFormId;
    this.dataset.productId
      ? (productFormId = `product-form-${this.dataset.productId}`)
      : (productFormId = `product-form-${this.dataset.section}`);

    let productForm = document.getElementById(productFormId);
    if (!productForm) productForm = document.getElementById('main_atc');

    if (!productForm) return;
    const addButtons = document.querySelectorAll('[name="add"]');

    if (!addButtons.length) return;

    for (let addButton of addButtons) {
      if (disable) {
        addButton.setAttribute('disabled', true);
        if (productForm.classList.contains('frequently-purchased-form')) {
          addButton.textContent = '+';
        } else {
          if (text) addButton.textContent = text;
        }
      } else {
        addButton.removeAttribute('disabled');
        if (productForm.classList.contains('frequently-purchased-form')) {
          addButton.textContent = '+';
        } else {
          if (
            !addButton.classList.contains('loading-button') &&
            !addButton.classList.contains('button-dont-change-text')
          ) {
            addButton.textContent = window.variantStrings.addToCart;
          }
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    let productFormId;
    // this.dataset.productId ?
    //     productFormId = `product-form-${this.dataset.productId}` :
    productFormId = `product-form-${this.dataset.section}`;
    const button = document.getElementById(productFormId) || document.getElementById('main_atc');
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.textContent = window.variantStrings.soldOut;
    //if (price) price.classList.add('visibility-hidden');
    this.hideSuggestionBundles();
  }

  updateStockIndicator() {
    if (!document.querySelector('#product-stock')) return;
    const stockData = JSON.parse(document.querySelector('#product-stock').textContent);
    const threshold = +document.querySelector('#product-stock').dataset.threshold;
    const stockIndicatorStatuses = document.querySelectorAll(
      '.stock-indicator .stock-indicator__status'
    );
    const stockIndicatorBlobs = document.querySelectorAll('.stock-indicator .blob');
    const stockIndicatorCaptions = document.querySelectorAll('.stock-indicator .caption');

    const currentVariantStockData = stockData.find(data => data.id === this.currentVariant.id);

    if (currentVariantStockData?.forced_low_stock === true) {
      stockIndicatorStatuses.forEach(stockIndicatorStatus => {
        stockIndicatorStatus.innerText = 'Low stock';
      });
      stockIndicatorBlobs.forEach(stockIndicatorBlob => {
        stockIndicatorBlob.dataset.color = 'amber';
      });
    } else if (currentVariantStockData?.available === false) {
      stockIndicatorStatuses.forEach(stockIndicatorStatus => {
        stockIndicatorStatus.innerText = 'Out of stock';
      });
      stockIndicatorBlobs.forEach(stockIndicatorBlob => {
        stockIndicatorBlob.dataset.color = 'red';
      });
    } else if (
      currentVariantStockData?.available === true &&
      currentVariantStockData?.inventory_policy === 'deny' &&
      currentVariantStockData?.inventory_management &&
      threshold &&
      currentVariantStockData?.inventory_quantity <= threshold
    ) {
      stockIndicatorStatuses.forEach(stockIndicatorStatus => {
        stockIndicatorStatus.innerText = 'Low stock';
      });
      stockIndicatorBlobs.forEach(stockIndicatorBlob => {
        stockIndicatorBlob.dataset.color = 'amber';
      });
    } else if (currentVariantStockData?.available === true) {
      stockIndicatorStatuses.forEach(stockIndicatorStatus => {
        stockIndicatorStatus.innerText = 'In stock';
      });
      stockIndicatorBlobs.forEach(stockIndicatorBlob => {
        stockIndicatorBlob.dataset.color = 'green';
      });
    }
    if (currentVariantStockData?.message) {
      stockIndicatorCaptions.forEach(stockIndicatorCaption => {
        stockIndicatorCaption.innerText = currentVariantStockData.message;
      });
    } else {
      stockIndicatorCaptions.forEach(stockIndicatorCaption => {
        stockIndicatorCaption.innerText = '';
      });
    }
  }

  getVariantData() {
    this.variantData = JSON.parse(this.querySelector('.js-product-variants').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.iscolorchanged = false;
    this.addEventListener('change', e => {
      if (e.target.name != 'quantity') {
        this.onVariantChange();
      }
    });
    Array.from(document.querySelectorAll('input[name="Colour"]')).forEach(el => {
      el.addEventListener('click', () => (this.iscolorchanged = true));
    });
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    if (!this.currentVariant || !this.currentVariant.available) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      this.updateMedia();
      this.renderProductInfo();
    } else {
      this.toggleAddButton(false, '', false);
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked).value;
    });
  }
  renderProductInfo() {
    document.querySelector('#selected-product').value = this.currentVariant.id;
    document.querySelector('legend.colour').innerHTML =
      'Colour: ' + document.querySelector('input[name="Colour"]:checked').value;

    // COUPON PRICES APPLYING
    let variantPrice = this.currentVariant.price;
    let variantComparePrice = this.currentVariant.compare_at_price;
    if (window.appliedCoupon) {
      let productHandle = this.dataset.url.split('/')[2].replace('-aff', '');
      if (
        !(
          window.appliedCoupon.exceptions && window.appliedCoupon.exceptions.includes(productHandle)
        ) &&
        !(window.appliedCoupon.hide && window.appliedCoupon.hide.includes(productHandle))
      ) {
        variantComparePrice = variantPrice;
        variantPrice =
          window.appliedCoupon.type == 'percentage'
            ? variantPrice * (1 - window.appliedCoupon.value / 100)
            : variantPrice - window.appliedCoupon.value;
      }
    }

    document.querySelectorAll('.js-price__savings').forEach(element => {
      if (variantComparePrice > variantPrice) {
        element.innerHTML = `(Save ${window.renderPrice(variantComparePrice - variantPrice)})`;
        element.classList.remove('hidden');
      } else {
        element.classList.add('hidden');
      }
    });

    Array.from(document.querySelectorAll('.main-price')).forEach(el => {
      el.innerHTML = renderPrice(variantPrice, variantComparePrice);
      window.setDivideBuyPrice(variantPrice / 100);
    });
    Array.from(document.querySelectorAll('.main-variant-title')).forEach(el => {
      el.innerText = this.currentVariant.title;
    });
    Array.from(document.querySelectorAll('.not-single')).forEach(el => {
      el.style.display = this.currentVariant.title == 'Single' ? 'none' : 'inline';
    });
  }
  updateMedia() {
    if (this.iscolorchanged) {
      let variant_image = this.currentVariant.featured_media.id;
      Array.from(document.querySelectorAll('.product-thumb')).forEach(el => {
        el.id != variant_image
          ? el.classList.remove('current')
          : (el.classList.add('current'), el.click());
      });
      this.iscolorchanged = false;
    }
  }
}
customElements.define('variant-radios', VariantRadios);

// Divan Bed PDP
class VariantRadiosBedframes extends VariantSelects {
  constructor() {
    super();
    // this.addEventListener('change', (e) => {
    //   if(e.target.name != 'quantity'){
    //     this.onVariantChange()
    //   }
    // });
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateRadios();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateStockIndicator();
    if (!this.currentVariant || !this.currentVariant.available) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.toggleAddButton(false, '', false);
      this.updateVariantInput();
    }
    this.updateURL();
    this.updateMedia();
    this.updateButtonForMattresses();
    this.updateSelected();
    this.renderProductInfo();
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;

    let utmCampaign;
    try {
      utmCampaign = decodeURIComponent(getUrlParameter('utm_campaign'));
    } catch (e) {}
    if (utmCampaign != 'undefined') {
      // setTimeout(() => {
      //   window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
      // }, 7000);
    } else {
      let handle = document.querySelector('input[name="bedframe-selector"]:checked').id;
      let path = window.location.pathname.split('/')[1];
      window.history.replaceState({}, '', `/${path}/${handle}?variant=${this.currentVariant.id}`);
    }
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked).value;
    });
    this.dataset.variant = this.options;
  }
  renderProductInfo() {
    // This is the function that runs when a bedframe is switched and everything gets re-rendered without reloading the page
    const selectedProductInput = document.querySelector('.bedframe-selector_product input:checked');
    const selectedProductWrapper = selectedProductInput.closest('.bedframe-selector_product');
    const selectedProductInfo = JSON.parse(
      selectedProductWrapper.querySelector('[data-bedframe-total-value-information]').textContent
    );
    const selectedVariantInfo = selectedProductInfo.variants.find(
      v => v.id === this.currentVariant.id
    );

    let dynamicInfos = document.querySelectorAll('.main-bedframe [class^="js-calc__"]');
    dynamicInfos.forEach(elem => {
      let variantTitle = this.currentVariant.title.split(' / ')[0];
      if (variantTitle == 'Small Double' && elem.dataset.sd == 'false') {
        elem.dataset.variant = 'Double';
      } else {
        elem.dataset.variant = this.currentVariant.title.split(' / ')[0];
      }
    });

    window.tempCouponSettings?.updatePricesOnSite();
    window.tempCouponSettings?.updateModalsOnSite();
    window.tempCouponSettings?.updateInstallmentsOnSite();
    window.tempCouponSettings?.updateLabelsOnSite();

    let variantPrice = this.currentVariant.price;
    let variantComparePrice = this.currentVariant.compare_at_price;
    if (!variantComparePrice) variantComparePrice = this.currentVariant.price;

    setTimeout(() => {
      let selectedMattressFieldset = document.querySelector(
        'fieldset[data-option="mattress-option"]'
      );
      if (selectedMattressFieldset) {
        let selectedMattress = selectedMattressFieldset.querySelector('input:checked');
        if (selectedMattress && selectedMattress.value !== 'No Mattress') {
          const mattresses = JSON.parse(document.querySelector('.js-mattresses').textContent);
          let mattressData = mattresses[selectedMattress.value];
          // console.log(mattressData);
          if (mattressData) {
            let currentVariantTitle = this.currentVariant.title;
            if (currentVariantTitle.includes('/')) {
              currentVariantTitle = currentVariantTitle.split('/')[0].trim();
            }
            let mattressVariant = mattressData.variants.find(
              variant => variant.title == currentVariantTitle
            );
            if (mattressVariant) {
              console.error(mattressVariant.price);
              variantPrice += mattressVariant.price;
            }
          }
        }
      }

      Array.from(document.querySelectorAll('.main-price:not(.main-price--separate)')).forEach(
        el => {
          el.innerHTML = renderPrice(variantPrice, variantComparePrice);
          window.setDivideBuyPrice(variantPrice / 100);
        }
      );

      Array.from(document.querySelectorAll('.main-price.main-price--separate')).forEach(el => {
        el.innerHTML = renderPrice(
          variantPrice,
          variantComparePrice ? variantComparePrice : variantPrice
        );
      });

      const financingSelectors = document.querySelectorAll('.financing');

      if (financingSelectors) {
        const price = variantPrice;
        financingSelectors.forEach(financing => {
          // Financing Calculator
          // Used in:
          // _src/scripts/components/Product.js
          // _src/scripts/components/LegacyBundleBuilder.js
          // assets/global.js
          // snippets/product-price.liquid
          // snippets/price-nectar.liquid
          // snippets/bundle-builder-variant-based.liquid
          // snippets/radiant-bundle-builder-metafields.liquid

          if (price >= window.radiant.dividebuyMinimumSpend * 100) {
            const thresholds = window.radiant.dividebuyThresholds;

            // Parse and filter thresholds where price qualifies
            const qualifyingOptions = thresholds
              .map(entry => {
                const [threshold, months] = entry.split(':');
                return {
                  threshold: Number(threshold) * 100, // Convert pounds to pence
                  months: Number(months)
                };
              })
              .filter(option => price >= option.threshold);

            // If no qualifying options, return null
            if (!qualifyingOptions.length) {
              financing.classList.add('hide');
            }

            // Get the option with the most months (lowest monthly payment)
            const bestOption = qualifyingOptions.reduce((best, current) =>
              current.months > best.months ? current : best
            );

            // Return the calculated monthly payment
            const calc = (price / bestOption.months / 100).toFixed(2);

            financing.querySelector('.financing__badge').innerHTML =
              `or <strong>${calc}</strong>/month`;

            financing.classList.remove('hide');
          } else {
            financing.classList.add('hide');
          }
        });
      }

      Array.from(
        document.querySelectorAll('.product__info-container [data-total-value-price]')
      ).forEach(el => {
        if (selectedVariantInfo && selectedVariantInfo.value > 0) {
          el.innerHTML =
            window.cartStrings.totalValue +
            ': ' +
            renderPrice(selectedVariantInfo.value) +
            `<span class="total-value-tooltip-icon" data-total-value-tooltip="${selectedVariantInfo.handle}|${selectedVariantInfo.id}">i</span>`;
        } else {
          el.innerHTML = '';
        }
      });

      let voucherBadges = [
        ...document.querySelectorAll('.voucher-col'),
        ...document.querySelectorAll('.voucher-element')
      ];

      voucherBadges.forEach(voucherBadge => {
        let handle = voucherBadge.dataset.handle;
        if (
          window.coupons?.applied?.voucher &&
          (!window.coupons?.applied?.exceptions ||
            !window.coupons?.applied?.exceptions.includes(handle)) &&
          window.coupons?.applied?.hide &&
          window.coupons?.applied?.hide.includes(handle)
        ) {
          if (voucherBadge.classList.contains('hidden')) {
            voucherBadge.classList.remove('hidden');
          }
        } else {
          if (!voucherBadge.classList.contains('hidden')) {
            voucherBadge.classList.add('hidden');
          }
        }
      });

      window.Collapses.map((collapse, index) => {
        if (collapse.element.classList.contains('bedframe-collapse')) {
          collapse.recalculate();
        }
      });

      document.querySelectorAll('.js-price__savings').forEach(element => {
        if (this.currentVariant.compare_at_price > this.currentVariant.price) {
          element.innerHTML = `(Save ${window.renderPrice(this.currentVariant.compare_at_price - this.currentVariant.price)})`;
          element.classList.remove('hidden');
        } else {
          element.classList.add('hidden');
        }
      });
    }, 100);
  }

  updateRadios() {
    // This is used on the bed frames pdp when switching variants
    const fieldsets = Array.from(
      this.querySelectorAll('fieldset:not([data-option="mattress-option"])')
    );
    this.options.map((option, index) => {
      if (fieldsets[index]) {
        Array.from(fieldsets[index].querySelectorAll('input')).map(radio => {
          let variations = Array.from(this.options);
          variations[index] = radio.value;
          let potential = this.getVariantData().find(variant => {
            return !variant.options
              .map((optionV, idx) => {
                return variations[idx] === optionV;
              })
              .includes(false);
          });

          if (!potential || potential.available == false) {
            if (!radio.checked && !radio.parentNode.classList.contains('disabled')) {
              radio.disabled = true;
              radio.parentNode.classList.add('disabled');
            }
          } else {
            if (radio.parentNode.classList.contains('disabled')) {
              radio.disabled = false;
              radio.parentNode.classList.remove('disabled');
            }
          }
        });
      }
    });
    let sdLabels = document.querySelectorAll('.js-calc__price[data-sd="false"]');
    if (this.currentVariant.title.split(' / ')[0] == 'Small Double') {
      sdLabels.forEach(label => {
        label.closest('.bedframe-selector__wrapper').classList.add('hidden');
      });
    } else {
      sdLabels.forEach(label => {
        label.closest('.bedframe-selector__wrapper').classList.remove('hidden');
      });
    }

    const smallDoubleSelector = document.querySelector(
      '.bedframe-selector__wrapper input[value="Small Double"] + label'
    );
    if (smallDoubleSelector) {
      const mattressFieldset = document.querySelectorAll(
        'fieldset[data-option="mattress-option"] .bedframe-selector__wrapper'
      );
      mattressFieldset.forEach(wrapp => {
        if (wrapp.querySelector('input:checked')) {
          if (wrapp.querySelector('[data-sd="false"]')) {
            if (!smallDoubleSelector.classList.contains('hidden'))
              smallDoubleSelector.classList.add('hidden');
          } else {
            if (smallDoubleSelector.classList.contains('hidden'))
              smallDoubleSelector.classList.remove('hidden');
          }
        }
      });
    }

    // const sdLabelsArray = Array.from(sdLabels);
    // for (let i = 0; i < sdLabelsArray.length; i++) {
    //   let label = sdLabelsArray[i];
    //   let wrapper = label.closest('.bedframe-selector__wrapper');
    //   console.log(wrapper);
    //   console.log(wrapper.querySelector('input:checked'));

    //   if (wrapper.querySelector('input:checked')) {
    //     console.log(smallDoubleSelector)
    //     if (!smallDoubleSelector.classList.contains('hidden')) smallDoubleSelector.classList.add('hidden');
    //   } else {
    //     if (smallDoubleSelector.classList.contains('hidden')) smallDoubleSelector.classList.remove('hidden');
    //   }

    // }
    // const hasSmallDouble = mattress.variants.some(elem => elem.title === 'Small Double');
    // const smallDoubleSelector = document.querySelector('.bedframe-selector__wrapper input[value="Small Double"]')
    // smallDoubleSelector.classList.toggle('hidden', !hasSmallDouble);

    window.Collapses.map((collapse, index) => {
      if (collapse.element.classList.contains('bedframe-collapse')) {
        collapse.recalculate();
      }
    });

    Array.from(
      document.querySelectorAll('.product__info-container [data-total-value-price]')
    ).forEach(el => {
      let totalValueId = el.dataset.id;
      if (totalValueId) {
        let totalValueInfo = JSON.parse(
          document.querySelector(`[data-total-value-information][data-id="${totalValueId}"]`)
            .innerHTML
        );
        let totalValueVariant = totalValueInfo.find(
          variant => variant.id == this.currentVariant.id
        );
        if (totalValueVariant && totalValueVariant.value > 0) {
          el.innerHTML =
            window.cartStrings.totalValue +
            ': ' +
            renderPrice(totalValueVariant.value) +
            `<span class="total-value-tooltip-icon" data-total-value-tooltip="${totalValueVariant.handle}|${totalValueVariant.id}">i</span>`;
        } else {
          el.innerHTML = '';
        }
      }
    });
    Array.from(
      document.querySelectorAll('.product__info-container [data-total-value-saving]')
    ).forEach(el => {
      let totalValueId = el.dataset.id;
      if (totalValueId) {
        let totalValueInfo = JSON.parse(
          document.querySelector(`[data-total-value-information][data-id="${totalValueId}"]`)
            .innerHTML
        );
        let totalValueVariant = totalValueInfo.find(
          variant => variant.id == this.currentVariant.id
        );
        if (totalValueVariant && totalValueVariant.value > 0) {
          let diff = totalValueVariant.value - this.currentVariant.price;
          el.innerHTML = 'Save ' + renderPrice(diff);
          el.style.display = 'block';
        } else {
          el.innerHTML = '';
          el.style.display = 'none';
        }
      }
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    setTimeout(() => {
      let gallery = document.querySelector('.product-gallery');
      if (gallery) {
        let variantImage = gallery.querySelector(
          `.swiper-slide[data-id='${this.currentVariant.id}']`
        );
        let index = +variantImage.getAttribute('aria-label')?.split('/')[0].replace(/ /g, '');
        if (index) {
          let swiper;
          if (window.productsSwiper) {
            swiper = window.productsSwiper;
          } else {
            swiper = gallery.querySelector('.swiper').swiper;
          }

          swiper.slideTo(index - 1);
        }
      }
    }, 500);
  }
  updateSelected() {
    const tabs = Array.from(document.querySelectorAll('.collapse__heading'));
    tabs.forEach(tab => {
      let selectedTitle = tab.querySelector('.collapse__selected');
      if (selectedTitle) {
        selectedTitle.innerHTML = tab.nextElementSibling
          .querySelector('input:checked')
          .value.replaceAll('-', ' ')
          .replaceAll('the nectar ', '');
      }
    });
  }
  updateButtonForMattresses() {
    const check = document.querySelector('fieldset[data-option="mattress-option"]');
    if (check) {
      const atcButton = document.querySelector('.product-form__buttons button');
      const mattresses = JSON.parse(document.querySelector('.js-mattresses').textContent);
      let quantity = 1;
      atcButton.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        let items = {};
        const vId = Number(
          document.querySelector('form[id^="product-form"] input[name="id"]').value
        );
        items[Number(vId)] = quantity;
        const fieldset = document.querySelector('fieldset[data-option="mattress-option"]');
        const input = fieldset.querySelector('input:checked');
        if (input.value !== 'No Mattress') {
          const size = document.querySelector('fieldset[data-option="size"] input:checked').value;
          const handle = input.value;
          const mattress = mattresses[handle];
          const variant = mattress.variants.find(elem => elem.title === size);
          items[variant.id] = quantity;
        }
        window.updateCart(items, () => {
          window.location.href = '/cart';
        });
      });
    }
  }
}

customElements.define('variant-radios-bedframes', VariantRadiosBedframes);
class VariantRadiosCard extends VariantSelects {
  constructor() {
    super();
  }
  onVariantChange() {
    this.updateMasterId();
    this.updateMedia();
    this.updateURL();
    this.updateStockIndicator();
    //this.updateSavings()
  }

  updateMasterId() {
    let variantId = this.querySelector('input[type="radio"]:checked').getAttribute(
      'data-variant-id'
    );
    this.currentVariant = this.getVariantData().find(el => el.id == variantId);
  }

  updateMedia() {
    let variantImage = this.querySelector('.media img');
    variantImage.src = this.currentVariant.featured_image.src;
    variantImage.srcset = '';
  }

  updateURL() {
    this.querySelector('.card--product a').href = this.querySelector(
      'input[type="radio"]:checked'
    ).getAttribute('data-variant-url');
    this.querySelector('.card-information__wrapper a').href = this.querySelector(
      'input[type="radio"]:checked'
    ).getAttribute('data-variant-url');
  }

  updateSavings() {
    document.querySelectorAll('.price__savings').forEach(element => {
      let variantPrice = this.currentVariant.price;
      let variantComparePrice = this.currentVariant.compare_at_price;
      if (variantComparePrice > variantPrice) {
        element.innerHTML = `(Save ${window.renderPrice(variantComparePrice - variantPrice)})`;
        element.classList.remove('hidden');
      } else {
        element.classList.add('hidden');
      }
    });
  }
}
customElements.define('variant-radios-card', VariantRadiosCard);
class variantDropdown extends VariantSelects {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('pageUpdated', e => {
      this.updateOptions();
      this.renderProductInfo();
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked).dataset
        .variant_title;
    });
  }
  updateVariantInput() {}

  renderProductInfo() {
    // COUPON PRICES APPLYING
    let variantPrice = this.currentVariant.price;
    let variantComparePrice = this.currentVariant.compare_at_price;
    let regularPrice = true;

    if (window.appliedCoupon) {
      let productHandle = this.dataset.url.split('/')[2];
      if (
        !(
          window.appliedCoupon.exceptions && window.appliedCoupon.exceptions.includes(productHandle)
        ) &&
        !(window.appliedCoupon.hide && window.appliedCoupon.hide.includes(productHandle))
      ) {
        variantComparePrice = variantPrice;
        variantPrice =
          window.appliedCoupon.type == 'percentage'
            ? variantPrice * (1 - window.appliedCoupon.value / 100)
            : variantPrice - window.appliedCoupon.value;
        regularPrice = false;
      }
    }

    document.querySelectorAll('.js-price__savings').forEach(element => {
      if (variantComparePrice > variantPrice) {
        element.innerHTML = `(Save ${window.renderPrice(variantComparePrice - variantPrice)})`;
        element.classList.remove('hidden');
      } else {
        element.classList.add('hidden');
      }
    });

    // if(document.querySelector('.dividebuy')) window.updateDivideBuy(variantPrice)
    if (document.querySelector('.product .js-calc__savings'))
      document.querySelector('.product .js-calc__savings').dataset.variant =
        this.currentVariant.title;
    if (window.tempCouponSettings) {
      if (window.tempCouponSettings.updatePricesOnSite) {
        window.tempCouponSettings.updatePricesOnSite();
      }
      if (window.tempCouponSettings.updateSavingsLabelsOnSite) {
        window.tempCouponSettings.updateSavingsLabelsOnSite();
      }
    }
    //window.mainOffer?.updateValue()

    let discountPercentage = 1;
    if (document.querySelector('[data-product-bundler-json]')) {
      let discountCode = localStorage.getItem('affiliate');
      let bundleJson = JSON.parse(document.querySelector('[data-product-bundler-json]').innerText);
      console.error('discount ting', getUrlParameter('discount'));
      if (discountCode && bundleJson && !window.getUrlParameter('discount')) {
        let discountToApply = bundleJson.discounts.find(discount => discount.code == discountCode);
        if (discountToApply) {
          discountPercentage = 1 - discountToApply.percentage / 100;
        }
      }
    }

    Array.from(document.querySelectorAll('.main-price')).forEach(el => {
      window.setDivideBuyPrice(variantPrice / 100);
      el.innerHTML = renderPrice(
        variantPrice * discountPercentage,
        variantComparePrice,
        2,
        regularPrice
      );
    });

    Array.from(
      document.querySelectorAll('.product__info-container [data-total-value-price]')
    ).forEach(el => {
      let totalValueId = el.dataset.id;
      if (totalValueId) {
        let totalValueInfo = JSON.parse(
          document.querySelector(`[data-total-value-information][data-id="${totalValueId}"]`)
            .innerHTML
        );
        let totalValueVariant = totalValueInfo.find(
          variant => variant.id == this.currentVariant.id
        );
        if (totalValueVariant && totalValueVariant.value > 0) {
          el.innerHTML =
            window.cartStrings.totalValue +
            ': ' +
            renderPrice(totalValueVariant.value) +
            `<span class="total-value-tooltip-icon" data-total-value-tooltip="${totalValueVariant.handle}|${totalValueVariant.id}">i</span>`;
        } else {
          el.innerHTML = '';
        }
      }
    });
    Array.from(
      document.querySelectorAll('.product__info-container [data-total-value-saving]')
    ).forEach(el => {
      let totalValueId = el.dataset.id;
      if (totalValueId) {
        let totalValueInfo = JSON.parse(
          document.querySelector(`[data-total-value-information][data-id="${totalValueId}"]`)
            .innerHTML
        );
        let totalValueVariant = totalValueInfo.find(
          variant => variant.id == this.currentVariant.id
        );
        if (totalValueVariant && totalValueVariant.value > 0) {
          let diff = totalValueVariant.value - this.currentVariant.price * discountPercentage;
          el.innerHTML = 'Save ' + renderPrice(diff);
          el.style.display = 'block';
        } else {
          el.innerHTML = '';
          el.style.display = 'none';
        }
      }
    });
    Array.from(document.querySelectorAll('.main-variant-title')).forEach(el => {
      el.innerText = this.currentVariant.title;
    });
    Array.from(document.querySelectorAll('.not-single')).forEach(el => {
      el.style.display = this.currentVariant.title == 'Single' ? 'none' : 'inline';
    });

    const financingBoxes = document.querySelectorAll('.financing-box');
    if (financingBoxes) {
      financingBoxes.forEach(financingBox => {
        const saving = variantComparePrice - variantPrice;
        if (saving > 0) {
          if (financingBox.querySelector('.saving-val'))
            financingBox.querySelector('.saving-val').innerHTML = renderPrice(saving);
        } else {
          if (financingBox.querySelector('.saving'))
            financingBox.querySelector('.saving').style.display = 'none';
        }

        const installmentsNumber = financingBox.dataset.installments;
        Array.from(financingBox.querySelectorAll('.financing-value')).forEach(el => {
          el.innerHTML = renderPrice(variantPrice / installmentsNumber);
        });

        // window.updateDivideBuy(variantPrice)
        // let klarna = document.querySelector('klarna-placement');
        // if(klarna){
        //   klarna.dataset.purchaseAmount = (variantPrice).toFixed(0);
        //   window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
        //   // window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
        //   window.Klarna.OnsiteMessaging.refresh()
        // }
      });
    }

    const sizeSelectFinancing = document.querySelectorAll('.size-select__financing');
    if (sizeSelectFinancing) {
      sizeSelectFinancing.forEach(element => {
        Array.from(element.querySelectorAll('.financing-value')).forEach(el => {
          const installmentsNumber = el.dataset.installments;
          const minimumNumber = el.dataset.minimum;
          if (+variantPrice / 100 >= +minimumNumber) {
            el.innerHTML = renderPrice(variantPrice / installmentsNumber);
            element.classList.remove('hidden');
          } else {
            element.classList.add('hidden');
          }
        });
      });
    }

    const bedFramesOffer = document.querySelector('.bed-frames-offer');
    if (bedFramesOffer) {
      let hideTitle = true;

      Array.from(bedFramesOffer.querySelectorAll('.offer-item')).forEach(item => {
        //console.log(item)
        if (item.dataset['size'] == this.currentVariant.title) {
          item.style.display = 'flex';
          hideTitle = false;
        } else {
          item.style.display = 'none';
        }
      });
      bedFramesOffer.querySelector('.block-title').style.display = hideTitle ? 'none' : 'block';
    }

    //compare table
    const compareTable = document.querySelector('.compare-table-section');

    if (compareTable) {
      let dynamic = false;
      if (compareTable.querySelector('#competitors-prices').dataset.dynamic == 'true')
        dynamic = true;

      let hidePrices = false;
      if (compareTable.querySelector('#competitors-prices').dataset.hide_prices == 'true')
        hidePrices = true;

      let size = this.currentVariant.title;
      if (compareTable.querySelector('#competitors-prices').dataset.size)
        size = compareTable.querySelector('#competitors-prices').dataset.size;

      const competitorsPrices = JSON.parse(
        compareTable.querySelector('#competitors-prices').textContent
      );
      const priceRow = compareTable.querySelector('.price-row');

      const dateElement = compareTable.querySelector('#scraping-date');
      const priceDesc = compareTable.querySelector('.prices-desc');
      const spell = compareTable.querySelector('.prices-desc__spell');
      const promotions = compareTable.querySelector('.prices-desc__promotions');
      const priceVoucherDesc = compareTable.querySelector('.table-desc p.voucher-element');
      const emmaCell = compareTable.querySelector('.emma');
      const simbaCell = compareTable.querySelector('.simba');
      const nectarPriceElement = compareTable.querySelector('#nectar-price .js-calc__price ins');
      console.log(nectarPriceElement);
      const correctLabel = compareTable.querySelector('.prices-desc__correct');
      // let nectarPrice = Number(nectarPriceElement?.textContent.replace('£','')) || (variantPrice / 100)
      let nectarPrice = Number(nectarPriceElement?.textContent.replace('£', ''));

      const currentTimeStamp = Date.now();

      let scrapingDate;
      const priceOk =
        competitorsPrices['King'] &&
        Object.values(competitorsPrices['King']).every(el => {
          const competitorPrice = Number(el[0]?.replace('£', ''));
          const timeDiff = currentTimeStamp - el[1];
          scrapingDate = new Date(Number(el[1]));
          return competitorPrice > nectarPrice;
        });

      simbaCell.innerText = competitorsPrices[size].simba[0];
      emmaCell.innerText = competitorsPrices[size].emma[0];
      dateElement.innerText = `${scrapingDate.getDate()}/${scrapingDate.getMonth() + 1}/${scrapingDate.getFullYear()}`;

      if ((priceOk && dynamic == true) || (dynamic == false && hidePrices == false)) {
        priceRow.style.display = 'flex';
        spell.innerText = 'Price compares';
        priceVoucherDesc.style.display = 'block';
        promotions.style.display = 'inline';
        correctLabel.style.display = 'inline';
      } else {
        priceRow.style.display = 'none';
        spell.innerText = 'The comparison between';
        priceVoucherDesc.style.display = 'none';
        promotions.style.display = 'none';
        correctLabel.style.display = 'none';
      }
    }

    const gwpCompareTable = document.querySelector('.gwp-compare-table-section');

    if (gwpCompareTable) {
      if (
        gwpCompareTable.querySelector('#competitors') &&
        document.querySelector('#gwp-products-data')
      ) {
        const competitors = JSON.parse(gwpCompareTable.querySelector('#competitors').textContent);
        const gwpProducts = JSON.parse(document.querySelector('#gwp-products-data').textContent);

        const size = this.currentVariant.title;
        if (!competitors) {
          console.error('Competitors not found');
          return;
        }
        let tableRows = gwpCompareTable.querySelectorAll('.table__row[data-product]');
        tableRows.forEach(tableRow => {
          let rowProductHandle = tableRow.dataset.product;
          if (!rowProductHandle) {
            console.error('Row product not found');
            return;
          }
          let tableCols = tableRow.querySelectorAll('.table__col.col__competitor-price');
          tableCols.forEach(tableCol => {
            let colCompetitor = tableCol.dataset.competitor;
            if (!colCompetitor) {
              console.error('Competitor not found');
              return;
            }
            let competitorProducts = competitors.find(
              competitor => competitor.handle == colCompetitor
            )?.products;
            if (!competitorProducts) {
              console.error('Competitor products not found');
              return;
            }
            if (tableRow.dataset.product == 'mattress') {
              rowProductHandle = tableCol.dataset.product;
              if (!rowProductHandle) {
                console.error('Mattress row product not found');
                return;
              }
            }
            let competitorProduct = competitorProducts.find(
              product =>
                product.handle == `${colCompetitor}-${rowProductHandle}` ||
                product.handle == rowProductHandle
            );
            if (!competitorProduct) {
              // console.error("Competitor product not found");
              tableCol.innerHTML =
                '<img src="https://cdn.shopify.com/s/files/1/0254/6309/5342/files/false_78ddb3a5-f32b-45f2-bbc4-fd032f62ea07.svg?v=1625046118" class="icon"/>';
              return;
            }
            if (competitorProduct[size]) {
              tableCol.innerHTML = renderPrice(competitorProduct[size]);
            } else {
              tableCol.innerHTML =
                '<img src="https://cdn.shopify.com/s/files/1/0254/6309/5342/files/false_78ddb3a5-f32b-45f2-bbc4-fd032f62ea07.svg?v=1625046118" class="icon"/>';
            }
          });

          let nectarTableCols = tableRow.querySelectorAll('.table__col[data-competitor="nectar"]');
          nectarTableCols.forEach(nectarTableCol => {
            if (tableRow.dataset.product == 'mattress') return;
            let rowProductHandle = tableRow.dataset.product;
            let gwpProduct = gwpProducts.products[rowProductHandle];
            let gwpProductVariant;
            const sizeVariant = gwpProduct.variants.find(variant => variant.title == size);
            // If 'size' is 'Small Double', check for 'Small Double' variant.
            // If 'Small Double' variant doesn't exist, use 'Double' variant.
            if (size === 'Small Double') {
              gwpProductVariant =
                sizeVariant || gwpProduct.variants.find(variant => variant.title == 'Double');
            } else {
              // Use the variant that matches 'size', if it exists.
              gwpProductVariant = sizeVariant;
            }
            if (gwpProductVariant)
              nectarTableCol.innerHTML = `<del>${renderPrice(gwpProductVariant.price)}</del>`;
          });
        });

        gwpCompareTable.querySelector('.main-variant-title').innerText = size;
        gwpCompareTable
          .querySelectorAll('.js-calc__price')
          .forEach(price => (price.dataset.variant = size));
        window.tempCouponSettings?.updatePricesOnSite();

        gwpCompareTable.querySelectorAll('.total-row .col__competitor-price').forEach(col => {
          let competitor = col.dataset.competitor;
          let compPrice = 0;
          gwpCompareTable
            .querySelectorAll(`.table__row:not(.total-row) [data-competitor="${competitor}"] ins`)
            .forEach(ins => {
              let insNumber = Number(ins.innerText.replace(/[^\d.-]/g, ''));
              if (insNumber > 0) compPrice += insNumber;
            });
          compPrice = compPrice.toFixed(2).replace('.00', '');
          if (compPrice > 0) {
            col.innerHTML = `<ins sale_price>£${compPrice}</ins>`;
          } else {
            col.innerHTML =
              '<img src="https://cdn.shopify.com/s/files/1/0254/6309/5342/files/false_78ddb3a5-f32b-45f2-bbc4-fd032f62ea07.svg?v=1625046118" class="icon"/>';
          }
        });

        let tableDesc = gwpCompareTable.querySelector('.table-desc');
        if (tableDesc) {
          let competitorsSpan = tableDesc.querySelector('.table-desc__competitors');
          let competitorMattresses = [];
          gwpCompareTable
            .querySelectorAll('.table__row[data-product="mattress"] .col__competitor-price')
            .forEach(col => {
              let competitorMattress = competitors
                .find(competitor => competitor.handle == col.dataset.competitor)
                ?.products.find(product => product.handle == col.dataset.product);
              if (competitorMattress) competitorMattresses.push(competitorMattress.display_name);
            });
          competitorsSpan.innerText = competitorMattresses.join(' and ');

          let date = new Date(competitors[0].date_stamp);
          competitors.forEach(item => {
            const currentDate = new Date(item.date_stamp);
            if (currentDate < date) {
              earliestDate = currentDate;
            }
          });

          let day = date.getDate();
          let month = date.getMonth() + 1; // getMonth() returns 0-11
          let year = date.getFullYear();
          let formattedDate = day + '/' + month + '/' + year;
          let dateStamp = tableDesc.querySelector('.table-desc__date-stamp');
          dateStamp.innerText = formattedDate;
        }

        let tableShouldBeHidden = false;
        let nectarTotalPrice = Number(
          gwpCompareTable
            .querySelector('.table__row.total-row .js-calc__price ins')
            ?.innerText.replace(/[^\d.-]/g, '')
        );
        let competitorsTotalPrices = gwpCompareTable.querySelectorAll(
          '.table__row.total-row .table__col.col__competitor-price ins'
        );
        if (competitorsTotalPrices.length == 0) tableShouldBeHidden = true;
        if (nectarTotalPrice) {
          for (let competitorTotalPrice of competitorsTotalPrices) {
            let competitorTotalPriceNumber = Number(
              competitorTotalPrice.innerText.replace(/[^\d.-]/g, '')
            );
            if (nectarTotalPrice > competitorTotalPriceNumber || competitorTotalPriceNumber === 0) {
              tableShouldBeHidden = true;
              break;
            }
          }
        }

        if (tableShouldBeHidden === true) {
          if (!gwpCompareTable.classList.contains('second-hidden'))
            gwpCompareTable.classList.add('second-hidden');
        } else {
          if (gwpCompareTable.classList.contains('second-hidden'))
            gwpCompareTable.classList.remove('second-hidden');
        }

        window.tempCouponSettings?.updateCompareTablesOnPDP();
      }
    }

    const bundlesContentWrap = document.querySelector('.bundle-content-wrap');
    if (bundlesContentWrap) {
      const bundlesIds = JSON.parse(document.querySelector('#bundle-ids').textContent);
      window.waitForBundles().then(data => {
        const bundle = data.find(
          bundle => bundle.id == bundlesIds[this.currentVariant.title].bundle_id
        );
        const handles = Object.values(bundle.products).map(product => product.handle);

        fetchProductsLoop(handles).then(data => {
          renderBundlesContent(bundlesContentWrap, data, bundle, this.currentVariant.title);
        });
      });
    }

    const mattressUpsellSection = document.querySelector(
      '.mattress-upsell-section:not(.cross-sell)'
    );

    if (mattressUpsellSection) {
      renderUpsell(mattressUpsellSection, this.currentVariant, variantPrice, variantComparePrice);
    }

    const crossSellSection = document.querySelector('.mattress-upsell-section.cross-sell');
    if (crossSellSection) {
      renderCrossSell(crossSellSection, this.currentVariant);
    }

    const emailFreeProduct = document.querySelector('.mattress-upsell__free-email-product');
    if (emailFreeProduct) {
      updateFreeEmailProduct(emailFreeProduct, this.currentVariant, mattressUpsellSection);
    }

    const suggestedBundlesContainer = document.querySelector('.suggested__bundles');
    if (suggestedBundlesContainer) {
      let mattress_form_inputs = document.querySelectorAll('.mattress_form input');
      let mattress_form = document.querySelector('.mattress_form');
      let mattress_type;

      mattress_form_inputs.forEach(el => {
        if (el.hasAttribute('checked')) {
          mattress_type = el.nextElementSibling.dataset.for;
        }
      });

      mattress_form.addEventListener('click', event => {
        let label = event.target.closest('label');
        if (!label.previousElementSibling.hasAttribute('checked')) {
          document.querySelector('.mattress_form input[checked]').removeAttribute('checked');
          label.previousElementSibling.setAttribute('checked', 'checked');
          mattress_type = label.dataset.for;

          renderAllBundles(
            suggestedBundlesContainer,
            this.currentVariant.id,
            this.currentVariant.option1,
            mattress_type,
            this.currentVariant.name
          );
        } else {
          // console.log('checked')
        }
      });

      renderAllBundles(
        suggestedBundlesContainer,
        this.currentVariant.id,
        this.currentVariant.option1,
        mattress_type,
        this.currentVariant.name
      );
    }

    let maxSavingGwpSection = document.querySelector('.select-size-section__gwp-max-saving');
    if (maxSavingGwpSection) {
      let maxSavingGwp;
      if (+this.currentVariant.compare_at_price > +this.currentVariant.price) {
        maxSavingGwp = +this.currentVariant.compare_at_price - +this.currentVariant.price;
      } else {
        maxSavingGwp = 0;
      }

      maxSavingGwpSection.innerHTML = `
        <p><span class="gwp-max-saving__price">£${maxSavingGwp % 100 == 0 ? maxSavingGwp / 100 : (maxSavingGwp / 100).toFixed(2)}</span> Total Saving With Mattress Discount + <span class="gwp-max-saving__gifts">Gifts</span></p>
      `;
    }

    const bundlesContentDetails = document.querySelector('.bundles-content-details');

    if (bundlesContentDetails) {
      renderInsideBundle(bundlesContentDetails, this.currentVariant);
    }

    const voucherSaving = document.querySelectorAll('.voucher__savings');
    voucherSaving.forEach(voucherSavings => {
      if (voucherSavings) {
        let notDiscountedPrice;
        if (voucherSavings.dataset.variant_price) {
          notDiscountedPrice = voucherSavings.dataset.variant_price;
        } else {
          notDiscountedPrice = document.querySelector('.product-form__input input:checked').dataset
            .variant_price;
        }
        if (!window.appliedCoupon) return null;
        let variantVoucherPrice =
          window.appliedCoupon.type == 'percentage'
            ? notDiscountedPrice * (1 - window.appliedCoupon.value / 100)
            : notDiscountedPrice - window.appliedCoupon.value;
        let coupon = window.coupons?.applied;
        let values = document.querySelectorAll(
          '.size-select-container .main-offer__discount-value'
        );
        values.forEach(elem => (elem.innerText = coupon.value));
        voucherSavings.innerHTML = ` - £${Math.floor((notDiscountedPrice - variantVoucherPrice) / 100)}`;
      }
    });

    let voucherBadges = [
      ...document.querySelectorAll('.voucher-col'),
      ...document.querySelectorAll('.voucher-element')
    ];

    voucherBadges.forEach(voucherBadge => {
      let handle = voucherBadge.dataset.handle;
      if (!handle) handle = window.location.pathname.replace('/products/', '');
      if (
        window.coupons?.applied?.voucher &&
        (!window.coupons?.applied?.exceptions ||
          !window.coupons?.applied?.exceptions.includes(handle)) &&
        window.coupons?.applied?.hide &&
        window.coupons?.applied?.hide.includes(handle)
      ) {
        if (voucherBadge.classList.contains('hidden')) {
          voucherBadge.classList.remove('hidden');
        }
      } else {
        if (!voucherBadge.classList.contains('hidden')) {
          voucherBadge.classList.add('hidden');
        }
      }
    });
  }
}
function renderInsideBundle(section, variant) {
  bundleIds = JSON.parse(section.querySelector('.bundle-content-object').innerText);
  bundleVariant = bundleIds[variant.title];
  let contentContainer = section.querySelector('.bundles-content__products__desktop');
  let contentContainerAdaptive = section.querySelector('.bundles-content__products__adaptive');

  waitForBundles().then(bundlesData => {
    let bundle = bundlesData.find(b => b.id == bundleVariant.bundle_id);
    let bundleProductsArray = Object.values(bundle.products).sort(
      (a, b) => a.discount_amount - b.discount_amount
    );
    let bundleHTML = [];
    let bundleHTMLAdaptive = [];
    let fetches = [];
    bundleProductsArray.forEach(bundleObject => {
      fetches.push(
        fetch(`/products/${bundleObject.handle}.js`)
          .then(response => response.json())
          .then(product => {
            let productVariant = product.variants
              .reverse()
              .find(
                v =>
                  v.title == variant.title ||
                  v.title == 'Default Title' ||
                  variant.title.includes(v.title)
              );
            let compareAtPrice = productVariant.compare_at_price || productVariant.price;
            let finalPrice = productVariant.price;
            let bundleItemDiscount = 0;
            switch (bundle.discount_type) {
              case 'products_discounts': {
                bundleItemDiscount = bundleObject.variants[bundleObject.id].discount_amount * 100;
                break;
              }
              case 'percentage': {
                bundleItemDiscount = Math.round(
                  (finalPrice * Number(bundle.percentage_value)) / 100
                );
              }
            }

            let price = productVariant.price - bundleItemDiscount;
            if (price < 0) price = 0;

            let title;
            product.title.toLowerCase().includes('2 premium pillows') && variant.title == 'Single'
              ? (title = product.title.toLowerCase().replace('2 premium pillows', 'premium pillow'))
              : (title = product.title.toLowerCase());

            //remove (pair) on pillow product in single bundles
            // product.handle.includes('premium-foam-pillow') && variant.title == 'Single' ?
            //   title = product.title.toLowerCase().replace('(pair)', '') :
            //   title = product.title.toLowerCase();

            bundleHTML.push({
              html: `
            <div class="row">
              <div class="col-md-6">
                <img
                src="${product.featured_image}"
                sizes="(min-width: 1400px) 650px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"
                alt="${title}">
              </div>

              <div class="col-md-6">
                <div class="bundle-content">
                  <h3>${title}</h3>
                  <div class="price" data-id="${product.id}">
                    ${renderPrice(price, compareAtPrice)}
                  </div>
                  <div class="description">
                    ${product.description}
                  </div>
                  <a href="
                  ${(function () {
                    if (product.title.toLowerCase().includes('2 premium pillows')) {
                      if (product.title.toLowerCase().includes('memory')) {
                        return '/products/memory-foam-mattress';
                      } else if (product.title.toLowerCase().includes('hybrid')) {
                        return '/products/hybrid-mattress';
                      }
                    } else {
                      return product.url;
                    }
                  })()}
                  " target="_blank" class="button btn-transparent">Learn More</a>
                </div>
              </div>
            </div>
          `,
              price
            });
          })

          // .then(() => lazyLoadImg.update())
          .then(() => {})
          .catch(err => {
            return console.error(err);
          })
      );
    });

    Promise.all(fetches).then(() => {
      contentContainer.innerHTML = '';
      sortedHTML = bundleHTML.sort((a, b) => b.price - a.price);
      sortedHTML.forEach((el, idx) => {
        contentContainer.innerHTML += el.html;
      });

      contentContainerAdaptive.innerHTML = `
        <div class="swiper bundle-content__swiper">
          <div class="swiper-wrapper">
          ${(function adaptiveContent() {
            let fullString = '';
            sortedHTML.forEach(el => {
              fullString += '<div class="swiper-slide">';
              fullString += el.html;
              fullString += '</div>';
            });
            return fullString;
          })()}
          </div>
          <div class="swiper-pagination"></div>
        </div>
      `;
      //lazyLoadImg.update()
      // This won't work since moving to global Swiper as part of PDP rebuild (Jan 26)
      const swiperBundleContent = new Swiper('.bundle-content__swiper', {
        loop: true,
        autoHeight: true,
        spaceBetween: 20,
        pagination: {
          el: '.bundles-content-details .swiper-pagination',
          clickable: true
        }
      });

      document.querySelector('.bundle-content__swiper').style.opacity = '1';
    });
  });
}

customElements.define('variant-dropdown', variantDropdown);

function updateFreeEmailProduct(section, mattressVariant, mattressUpsellSection) {
  let mattressHandle = mattressUpsellSection && mattressUpsellSection.dataset.handle;
  // Return early if the mattress handle is not eligible for a free gift
  let freeProductColElements = document.querySelectorAll('.free-product-col');
  if (!window.coupons?.applied?.free_gift_mattresses?.includes(mattressHandle)) {
    freeProductColElements.forEach(element => {
      if (!element.classList.contains('hidden')) element.classList.add('hidden');
    });
    return;
  }
  let selectedMattressVariant = mattressVariant.title;
  let productData = JSON.parse(section.querySelector('#free-email-product__data').textContent);
  let variant;
  if (productData.tags.includes('Shopify Bundle')) {
    if (selectedMattressVariant == 'Small Double') {
      variant = productData.variants.find(
        v =>
          v.options.some(option => option === 'Small Double') &&
          v.options.every(option => option.includes('Double'))
      );
    } else {
      variant = productData.variants.find(v =>
        v.options.every(option => option.includes(selectedMattressVariant))
      );
    }
  } else {
    if (selectedMattressVariant == 'Small Double') selectedMattressVariant = 'Double';
    variant = productData.variants.find(v => v.title == selectedMattressVariant);
  }
  if (section) section.classList.remove('hidden');
  let input = section.querySelector('.free-email-product__label input');
  let title = section.querySelector('.free-email-product__title');
  let prices = section.querySelector('.free-email-product__price-snippet');
  title.dataset.size = variant.title;
  input.dataset.ids = variant.id;
  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    prices.innerHTML = window.renderPrice(variant.compare_at_price);
    title.dataset.compare_at_price = variant.compare_at_price;
  } else {
    prices.innerHTML = window.renderPrice(variant.price);
    title.dataset.compare_at_price = variant.price;
  }
  freeProductColElements.forEach(element => {
    if (element.classList.contains('hidden')) element.classList.remove('hidden');
  });
}

function renderUpsell(mattressUpsellSection, mattressVariant, variantPriceF, variantComparePriceF) {
  const productsData = JSON.parse(document.querySelector('#upsell-products-data').textContent);
  //console.log(productsData)
  let useBundles;
  mattressUpsellSection.querySelector('.essential-add')
    ? (useBundles = mattressUpsellSection
        .querySelector('.essential-add')
        .classList.contains('added'))
    : (useBundles = false);

  let maxSaving = 0,
    beddingSaving = 0,
    framesSaving = 0;

  //bedding
  if (mattressUpsellSection.querySelector('.upsell')) {
    Array.from(mattressUpsellSection.querySelectorAll('.upsell')).forEach(item => {
      //console.log(item.dataset)
      const handle = item.dataset.handle;

      if (!handle) return;

      const variantTitle = mattressVariant.title;
      const upsellProduct = productsData.upsellProducts[handle];

      if (!upsellProduct) return;

      const upsellVariants = upsellProduct.variants;
      let smallDouble = false; // Initialize smallDouble to track the selection

      let upsellVariant;

      // First, explicitly look for 'Small Double' if the desired variant is 'Small Double'
      if (variantTitle === 'Small Double') {
        upsellVariant = upsellVariants.find(variant => variant.title === 'Small Double');
      }

      // If 'Small Double' was not found or not the target, look for the original logic
      if (!upsellVariant) {
        if (variantTitle === 'Small Double') {
          // If we're here, it means 'Small Double' was not found; try 'Double' next
          upsellVariant = upsellVariants.find(variant => variant.title === 'Double');
          if (upsellVariant) smallDouble = true; // If found, set smallDouble to true
        } else {
          // For any other case, follow the original matching logic
          upsellVariant = upsellVariants.find(
            variant => variant.title === variantTitle || variant.title === 'Default Title'
          );
        }
      }

      if (!upsellVariant) {
        item.parentNode.classList.add('hidden');
        // if(mattressUpsellSection.querySelector('.separator') && !mattressUpsellSection.querySelector('.separator').classList.contains('hidden'))
      } else {
        const addBtn = item.querySelector('.upsell-add');
        let isBundle = upsellVariant.name.toLowerCase().includes('bundle') ? true : false;
        let compareAtPrice, price;

        window.initStarterBundlePrice = () => {
          if (
            isBundle &&
            !window.coupons?.applied?.hide.includes(mattressUpsellSection.dataset.handle) &&
            !window.coupons?.applied?.exceptions.includes(mattressUpsellSection.dataset.handle)
          ) {
            // let bedframeAdd = mattressUpsellSection.querySelector('.frames-block .upsell-add.added')
            // if(!bedframeAdd){
            // }
            compareAtPrice =
              upsellVariant.compare_at_price - variantComparePriceF ||
              upsellVariant.price - variantPriceF;
            price = upsellVariant.price - variantPriceF;
          } else {
            compareAtPrice = upsellVariant.compare_at_price || upsellVariant.price;
            price = upsellVariant.price;
          }
          let bundleBadge = mattressUpsellSection.querySelector('.bedding-block__bundle-badge');
          if (bundleBadge && isBundle && upsellVariant) {
            let badgeValue = Math.floor(
              100 - (upsellVariant.price / upsellVariant.compare_at_price) * 100
            );
            bundleBadge.innerHTML = `${badgeValue}% OFF`;
          }
          let giftMessage = item
            .closest('.upsell-item')
            .querySelector('.single-gift-wrap__message');
          if (smallDouble == true && giftMessage) {
            giftMessage.textContent = '*Double';
          } else if (giftMessage) {
            giftMessage.textContent = '';
          }

          if (addBtn.dataset.free == 'true') {
            //compareAtPrice = price;
            price = 0;

            window._freeGiftActivated = window._freeGiftActivated || new Set();

            if (
              !coupons?.marketing.split(', ').includes(coupons?.applied?.title) &&
              !window._freeGiftActivated.has(addBtn.dataset.ids)
            ) {
              addBtn.classList.add('added');
              window._freeGiftActivated.add(addBtn.dataset.ids);
            }
          }

          const financingMessage = item.querySelector('.upsell-financing-value');

          if (price) {
            item.querySelector('.price').innerHTML = window.renderPrice(price, compareAtPrice);
            if (financingMessage) {
              financingMessage.innerHTML = window.renderPrice(
                price / financingMessage.dataset.installments
              );
            }
          }
          addBtn.dataset.price = price;
          addBtn.dataset.compare_at_price = compareAtPrice;
        };
        initStarterBundlePrice();

        if (
          item.dataset.handle.includes('pillow') &&
          !item.dataset.tags.includes('Shopify Bundle')
        ) {
          if (mattressVariant.title == 'Single') {
            item.parentNode.querySelector('.free-gift__strong').innerHTML = upsellVariant.name
              .replace(/ the nectar/gim, '')
              .replace(/ nectar/gim, '')
              .replace(/ \(pair\)/gim, '');
            item.parentNode.querySelector('.free-gift__gift-title').innerHTML =
              `Free ${upsellVariant.name
                .toLowerCase()
                .replace(/ the nectar/gim, '')
                .replace(/ nectar/gim, '')
                .replace(/ \(pair\)/gim, '')}`;
            let pillowSrc =
              'https://cdn.shopify.com/s/files/1/0254/6309/5342/files/single-pillow_1.png?v=1639067355';
            item.parentNode.querySelector('.image').querySelector('img').src = pillowSrc;
          } else {
            item.parentNode.querySelector('.free-gift__strong').innerHTML = upsellVariant.name
              .replace(/ the nectar/gim, '')
              .replace(/ nectar/gim, '');
            if (item.parentNode.querySelector('.free-gift__gift-title'))
              item.parentNode.querySelector('.free-gift__gift-title').innerHTML =
                `Free ${upsellVariant.name
                  .toLowerCase()
                  .replace(/ the nectar/gim, '')
                  .replace(/ nectar/gim, '')}`;
            let pillowSrc =
              'https://cdn.shopify.com/s/files/1/0254/6309/5342/files/Mask_Group-1_1.png?v=1638284151';
            item.parentNode.querySelector('.image').querySelector('img').src = pillowSrc;
          }
        } else {
          item.parentNode.querySelector('modal-opener button').dataset['size'] =
            upsellVariant.title;
        }

        item.parentNode.classList.remove('hidden');

        // if(mattressUpsellSection.querySelector('.separator') && mattressUpsellSection.querySelector('.separator').classList.contains('hidden'))
        mattressUpsellSection.querySelector('.separator').classList.remove('hidden');

        if (addBtn.dataset.handle) {
          const bundleMetafields = productsData.bundlesMetafields[addBtn.dataset.handle];

          if (bundleMetafields && bundleMetafields[mattressVariant.title]) {
            const bundlerId = bundleMetafields[mattressVariant.title].bundle_id;

            window.waitForBundles().then(data => {
              const bundle = data.find(bundle => bundle.id == bundlerId);
              if (bundle && bundle.product_level == 'variant') {
                addBtn.dataset.ids = Object.keys(bundle.products).join(',');
              } else if (bundle && bundle.product_level == 'product') {
                fetchProductsLoop(Object.values(bundle.products).map(p => p.handle)).then(data => {
                  let dataIds = [];
                  data.forEach(productData => {
                    let selectedVariant = productData.variants
                      .reverse()
                      .find(
                        variantData =>
                          variantData.title === mattressVariant.title ||
                          variantData.title === 'Default Title' ||
                          mattressVariant.title.includes(variantData.title)
                      );
                    dataIds.push(selectedVariant.id);
                  });
                  addBtn.dataset.ids = dataIds.join(',');
                });
              }
            });
          }
        } else if (addBtn.dataset.mattress_with_pillows) {
          let mattressWithPillows = productsData.upsellProducts[
            addBtn.dataset.mattress_with_pillows
          ].variants.find(variant => variant.title == mattressVariant.title);
          addBtn.dataset.ids = mattressWithPillows.id;
        } else {
          addBtn.dataset.ids = upsellVariant.id;
        }

        //bedding badge
        let beddingBadge = item.querySelector('.upsell-row__discount-badge');
        if (beddingBadge) {
          let percentDiscount = 100 - (price * 100) / compareAtPrice;
          if (percentDiscount > 0) {
            beddingBadge.innerText = `${Math.floor(percentDiscount)}% OFF`;
          }
        }
      }
    });
  }

  if ([...mattressUpsellSection.querySelectorAll('.upsell-item.hidden')].length === 2) {
    if (
      mattressUpsellSection.querySelector('.separator') &&
      !mattressUpsellSection.querySelector('.separator').classList.contains('.hidden')
    )
      mattressUpsellSection.querySelector('.separator').classList.add('hidden');
  } else {
    if (
      mattressUpsellSection.querySelector('.separator') &&
      mattressUpsellSection.querySelector('.separator').classList.contains('.hidden')
    )
      mattressUpsellSection.querySelector('.separator').classList.remove('hidden');
  }

  //trustpilots

  mattressUpsellSection.querySelectorAll('.trustpilot-widget').forEach(trustpilot => {
    try {
      window.Trustpilot.loadFromElement(trustpilot);
    } catch (e) {
      console.log('Trustpilot loading...');
    }
  });

  //savings
  maxSaving = Object.values(productsData.upsellProducts).reduce((max, product) => {
    const maxVariant = product.variants.find(variant => variant.title == mattressVariant.title);
    if (maxVariant) {
      const curSaving = maxVariant.compare_at_price - maxVariant.price;
      return max < curSaving ? curSaving : max;
    }
    return max;
  }, 0);

  Array.from(mattressUpsellSection.querySelectorAll('.bedding-block .upsell-add')).forEach(
    addBtn => {
      if (addBtn.classList.contains('added')) {
        beddingSaving = addBtn.dataset.compare_at_price - addBtn.dataset.price;
      }
    }
  );

  if (beddingSaving) {
    mattressUpsellSection.querySelector('.upsell-savings_bedding').classList.remove('hidden');
    if (mattressUpsellSection.querySelector('.save-up-to'))
      mattressUpsellSection.querySelector('.save-up-to').classList.add('hidden');
    mattressUpsellSection.querySelector('.upsell-savings_bedding .upsell-saving-value').innerHTML =
      window.renderPrice(beddingSaving);
  } else {
    mattressUpsellSection.querySelector('.upsell-savings_bedding').classList.add('hidden');
    if (mattressUpsellSection.querySelector('.save-up-to'))
      mattressUpsellSection.querySelector('.save-up-to').classList.remove('hidden');
  }
  if (useBundles) {
    Array.from(mattressUpsellSection.querySelectorAll('.essential-message')).forEach(message => {
      message.classList.add('hidden');
    });
  } else {
    Array.from(mattressUpsellSection.querySelectorAll('.essential-message')).forEach(message => {
      message.classList.remove('hidden');
    });
  }

  //bed frames
  // const bedFrameUpsell = mattressUpsellSection.querySelector('.frames-block .upsell-row');

  Array.from(document.querySelectorAll('.frames-carousel .upsell-col')).forEach(item => {
    // let bedFrameUpsells = Array.from(document.querySelectorAll('.item__bedframe .upsell-row'));
    const handle = item.dataset.handle;
    const bundleVariant = productsData.upsellProducts[handle].variants.find(
      variant => variant.title == mattressVariant.title
    );
    const bundleMetafield = productsData.bundlesMetafields[handle][mattressVariant.title];
    //console.log(bundleMetafield)

    let bedFrameMetafield;
    try {
      bedFrameMetafield = productsData.bedFramesMetafields;
    } catch (e) {}

    window.waitForBundles().then(data => {
      let bedFrameUpsells = Array.from(document.querySelectorAll('.item__bedframe .upsell-row'));
      bedFrameUpsells.forEach(bedFrameUpsell => {
        if (bundleVariant && bundleVariant.available) {
          const bundle = data.find(bundle => bundle.id == Number(bundleMetafield.bundle_id));
          let bedFrame = null;
          const productBundler = Object.values(bundle.products).find(prod => {
            if (
              productsData.upsellProducts[prod.handle] &&
              productsData.upsellProducts[prod.handle].type == 'Bed Frame'
            ) {
              bedFrame = productsData.upsellProducts[prod.handle];
              return prod;
            }
          });

          let bedFrameTitle, bedFrameVariant, bedFrameTitleShort;
          if (bedFrame) {
            bedFrameTitle = bedFrame.title.toLowerCase();
            bedFrameTitleShort = bedFrame.title
              .toLowerCase()
              .replace('the', '')
              .replace('nectar', '')
              .replace('frame', '')
              .replace('bed', '');
            bedFrameVariant = bedFrame.variants.find(
              variant => variant.title == mattressVariant.title
            );
          }

          if (!bedFrameVariant) return;

          item.querySelector('.info-title').innerText = bedFrameTitleShort;
          if (document.querySelector('.gwp-content-wrap')) useBundles = true;
          const compareAtPrice = bedFrameVariant?.compare_at_price || bedFrameVariant?.price;
          let price;
          if (
            useBundles &&
            (window.coupons?.applied?.hide.includes(mattressUpsellSection.dataset.handle) ||
              window.coupons?.applied?.exceptions.includes(mattressUpsellSection.dataset.handle))
          ) {
            let essentialPrice = Number(document.querySelector('.essential-add').dataset.price);
            price = bundleVariant.price - essentialPrice;
          } else if (useBundles) {
            price = calcPrice(
              bedFrameVariant.price,
              productBundler.discount_amount,
              bundle.discount_type,
              bundle.percentage_value
            );
          } else {
            price = bedFrameVariant.price;
          }
          item.querySelector('.price').innerHTML = window.renderPrice(price, compareAtPrice);
          item.dataset.price = price;
          item.dataset.compare_at_price = compareAtPrice;

          if (item.classList.contains('selected')) {
            const modalOpener = bedFrameUpsell.querySelector('modal-opener button');
            const addBtn = document.querySelector('.upsell-item.item__bedframe .upsell-add');
            const financingMessage =
              bedFrameUpsell.parentElement.parentElement.parentElement.querySelector(
                '.upsell-financing-value.frames-financing'
              );
            bedFrameUpsell.querySelector('.image img').setAttribute('src', bedFrame.featured_image);
            bedFrameUpsell.parentElement.parentElement.parentElement.querySelector(
              '.price.frames'
            ).innerHTML = window.renderPrice(price, compareAtPrice);

            //short description on bed-frames
            let description = document.createElement('div');
            description.innerHTML = bedFrame.description;
            description = description.querySelector('.bed-frame__short-description');
            let shortDescription = bedFrameUpsell.querySelector('.upsell__short-description');
            let secondDescription = bedFrameUpsell.querySelector('.frames__description');
            if (description && shortDescription) {
              shortDescription.innerText = description.innerText;
              shortDescription.classList.remove('hidden');
            } else if (shortDescription && !shortDescription.classList.contains('hidden')) {
              shortDescription.classList.add('hidden');
            }

            //bed-frames trustpilot
            let bedFrameTP = bedFrameUpsell.querySelector('.upsell__trustpilot-widget');
            if (bedFrameMetafield && bedFrameTP) {
              bedFrameTP.innerHTML = bedFrameMetafield[bedFrame.handle].trustpilot_widget;
              window.Trustpilot.loadFromElement(bedFrameTP.querySelector('.trustpilot-widget'));
              bedFrameTP.classList.remove('hidden');
              if (
                bedFrameTP.innerText == 'undefined' &&
                bedFrameTP &&
                !bedFrameTP.classList.contains('hidden')
              )
                bedFrameTP.classList.add('hidden');
            }

            //bed-frames badge
            let bedFrameBadge = bedFrameUpsell.querySelector('.upsell-block__badge');
            if (bedFrameBadge) {
              let percentDiscount =
                100 - (bedFrameVariant.price * 100) / bedFrameVariant.compare_at_price;
              if (percentDiscount >= 50) {
                bedFrameBadge.innerText = `${Math.floor(percentDiscount)}% OFF`;
              } else {
                bedFrameBadge.innerText = '';
              }
            }

            financingMessage.innerHTML = window.renderPrice(
              price / financingMessage.dataset.installments
            );
            modalOpener.dataset['size'] = bedFrameVariant.title;
            modalOpener.dataset['url'] = '/products/' + bedFrame.handle;
            modalOpener.dataset['price'] = price;
            modalOpener.innerText = bedFrameTitle;
            bedFrameUpsell.classList.remove('hidden');
            bedFrameUpsell.parentElement.classList.remove('hidden');
            bedFrameUpsell.parentElement?.parentElement
              ?.querySelector('.separator')
              ?.classList.remove('second-hidden');
            addBtn.dataset.ids = bedFrameVariant.id;
            addBtn.dataset.bundle_id = bundle.id;

            //BUNDLE PRICE UPDATING WITH BEDFRAMES
            window.bundlePriceUpdateWithBeds = () => {
              if (
                !window.coupons?.applied?.exceptions.includes(
                  mattressUpsellSection.dataset.handle
                ) &&
                !window.coupons?.applied?.hide.includes(mattressUpsellSection.dataset.handle)
              ) {
                let essentialBlock = mattressUpsellSection.querySelector(
                  '.bedding-block .upsell-row[data-bundle="true"]'
                );
                if (!essentialBlock.querySelector('.upsell-button').classList.contains('added'))
                  return null;
                let comparePriceEssential =
                  bundleVariant.compare_at_price - variantComparePriceF - compareAtPrice ||
                  bundleVariant.price - variantPriceF - price;
                let priceEssential = bundleVariant.price - variantPriceF - price;
                essentialBlock.querySelector('.price').innerHTML = window.renderPrice(
                  priceEssential,
                  comparePriceEssential
                );
                essentialBlock.querySelector('.upsell-add').dataset.price = priceEssential;
                essentialBlock.querySelector('.upsell-add').dataset.compare_at_price =
                  comparePriceEssential;
                const financingMessageEssential =
                  essentialBlock.querySelector('.upsell-financing-value');
                if (financingMessageEssential) {
                  financingMessageEssential.innerHTML = window.renderPrice(
                    priceEssential / financingMessage.dataset.installments
                  );
                }
              }
            };
            if (addBtn.classList.contains('added')) {
              framesSaving = useBundles
                ? bundleVariant.compare_at_price - bundleVariant.price
                : compareAtPrice - price;
              mattressUpsellSection.querySelector('.upsell-savings_all').classList.remove('hidden');
              if (mattressUpsellSection.querySelector('.frame-mesage'))
                mattressUpsellSection.querySelector('.frame-mesage').classList.remove('hidden');
              // save-up-to fix not hiding GWP

              //if(document.querySelector('.gwp-content-wrap'))  mattressUpsellSection.querySelector('.save-up-to').classList.add('hidden')
              bundlePriceUpdateWithBeds();
            } else {
              mattressUpsellSection.querySelector('.upsell-savings_all').classList.add('hidden');
              if (mattressUpsellSection.querySelector('.frame-mesage'))
                mattressUpsellSection.querySelector('.frame-mesage').classList.add('hidden');
              // save-up-to fix not hiding GWP

              //if(document.querySelector('.gwp-content-wrap'))  mattressUpsellSection.querySelector('.save-up-to').classList.remove('hidden')
            }
          }

          const finalSaving = useBundles ? framesSaving : framesSaving + beddingSaving;
          if (finalSaving) {
            if (finalSaving < maxSaving) {
              mattressUpsellSection.querySelector(
                '.upsell-savings_all .upsell-saving-value'
              ).innerHTML = window.renderPrice(finalSaving);
            } else {
              mattressUpsellSection.querySelector(
                '.upsell-savings_all .upsell-saving-value'
              ).innerHTML = window.renderPrice(finalSaving) + ' (MAX)';
            }
          }

          if (finalSaving < maxSaving) {
            Array.from(mattressUpsellSection.querySelectorAll('.max-message')).forEach(message => {
              message.classList.remove('hidden');
            });
            Array.from(mattressUpsellSection.querySelectorAll('.max-saving')).forEach(message => {
              message.innerHTML = window.renderPrice(maxSaving);
            });
          } else {
            Array.from(mattressUpsellSection.querySelectorAll('.max-message')).forEach(message => {
              message.classList.add('hidden');
            });
          }

          item.classList.remove('hidden');
          // if(mattressUpsellSection.querySelectorAll('.upsell-col.hidden').length < 3){

          // }else{
          //   document.querySelector('.upsell-block.frames-block').classList.add('hidden');
          // }

          if (mattressUpsellSection.querySelectorAll('.hidden.upsell-col').length < 3) {
            document.querySelector('.upsell-block.frames-block').classList.remove('hidden');
            // save-up-to fix not hiding GWP

            //document.querySelector('.save-up-to').classList.remove('hidden')
          } else {
            document.querySelector('.upsell-block.frames-block').classList.add('hidden');
            document.querySelector('.save-up-to').classList.add('hidden');
          }
        } else {
          item.classList.add('hidden');
          if (item.classList.contains('selected')) {
            bedFrameUpsell.classList.add('hidden');
            bedFrameUpsell.parentElement.classList.add('hidden');
            bedFrameUpsell.parentElement?.parentElement
              ?.querySelector('.separator')
              ?.classList.add('second-hidden');
          }
          if (mattressUpsellSection.querySelectorAll('.hidden.upsell-col').length < 3) {
            document.querySelector('.upsell-block.frames-block').classList.remove('hidden');
            // document.querySelector('.save-up-to').classList.remove('hidden')
          } else {
            document.querySelector('.upsell-block.frames-block').classList.add('hidden');
            // document.querySelector('.save-up-to').classList.add('hidden')
          }
        }
      });

      if (
        mattressUpsellSection.querySelector('.upsell-item:not(.hidden)') ||
        mattressUpsellSection.querySelector('.frames-block:not(.hidden)')
      ) {
        mattressUpsellSection.classList.remove('hidden');
        if (document.querySelector('.mattress-upsell__loading'))
          document.querySelector('.mattress-upsell__loading').classList.add('hidden');
      }

      document
        .querySelectorAll('.upsell-block.frames-block .upsell-add.upsell-button')
        .forEach(elem => {
          elem.addEventListener('click', e => {
            e.stopPropagation();
            if (e.target.classList.contains('upsell-add') && window.divanBedUpsell) {
              window.divanBedUpsell.checkButtons();
            }
            if (e.target.classList.contains('upsell-add') && window.bedframeUpsell) {
              window.bedframeUpsell.checkButtons();
            }
          });
        });

      // divan-bed
    });

    // })
  });
  if (!window.divanBedUpsell) {
    window.divanBedUpsell = new DivanBedUpsell();
  }
  // if(!window.bedframeUpsell){
  //   window.bedframeUpsell = new BedframeUpsell();
  //   console.log('class instance created')
  // }
  // else{
  //   window.divanBedUpsell = ''
  //   window.divanBedUpsell = new DivanBedUpsell;
  // }

  //
  window.recalculateTotal = () => {
    setTimeout(() => {
      let totalUpsellPrice = variantPriceF;
      let totalUpsellComparePrice = variantComparePriceF || variantPriceF;

      Array.from(mattressUpsellSection.querySelectorAll('.bedding-block .upsell-item')).forEach(
        item => {
          let itemElement = item.querySelector('.upsell-add.added');
          if (itemElement) {
            totalUpsellPrice += +itemElement.dataset.price;
            totalUpsellComparePrice += itemElement.dataset.compare_at_price
              ? +itemElement.dataset.compare_at_price
              : +itemElement.dataset.price;
          }
        }
      );

      let framesBlockWrapper = mattressUpsellSection.querySelector('.frames-block');
      let divanBedButton = framesBlockWrapper.querySelector(
        '.upsell-button.divan-bed__popup-button.added'
      );

      if (framesBlockWrapper.querySelector('.upsell-add.added')) {
        document.querySelectorAll('.bedframe-popup__wrapper .upsell-col').forEach(item => {
          if (item.classList.contains('selected') && !item.classList.contains('hidden')) {
            totalUpsellPrice += +item.dataset.price;
            totalUpsellComparePrice += item.dataset.compare_at_price
              ? +item.dataset.compare_at_price
              : item.dataset.price;
          } else {
            totalUpsellPrice += 0;
            totalUpsellComparePrice += 0;
          }
        });
      } else if (divanBedButton) {
        totalUpsellPrice += +divanBedButton.dataset.price;
        totalUpsellComparePrice +=
          divanBedButton.dataset.compare_at_price != 'null'
            ? +divanBedButton.dataset.compare_at_price
            : +divanBedButton.dataset.price;
      }

      if (!document.querySelector('.dropdown-size-selector__total-wrapper')) {
        let cartGroup = document.querySelector('#main_atc .cart-group');
        let totalWrapper = document.createElement('div');
        totalWrapper.classList.add('dropdown-size-selector__total-wrapper');
        cartGroup.prepend(totalWrapper);
      }
      if (totalUpsellPrice) {
        document.querySelector('.dropdown-size-selector__total-wrapper').innerHTML = `
          <div class="total-wrapper__text">
            <p>Total: </p>
            <div class="total-wrapper__price">
              ${window.renderPrice(totalUpsellPrice, totalUpsellComparePrice)}
            </div>
          </div>
        `;

        // window.updateDivideBuy(totalUpsellPrice)
        // let klarna = document.querySelector('klarna-placement');
        // if(klarna){
        //   klarna.dataset.purchaseAmount = (totalUpsellPrice).toFixed(0);
        //   window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
        //   // window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
        //   window.Klarna.OnsiteMessaging.refresh()
        // }
      }
    }, 100);
  };
  recalculateTotal();
}

function renderCrossSell(crossSellSection, mattressVariant) {
  const productsData = JSON.parse(
    crossSellSection.querySelector('#cross-sell-products-data').textContent
  );
  if (crossSellSection.querySelector('.upsell')) {
    Array.from(crossSellSection.querySelectorAll('.upsell')).forEach(item => {
      //console.log(item.dataset)
      const handle = item.dataset.handle;
      let smallDouble = false;
      const upsellVariant = productsData.upsellProducts[handle].variants.find(variant => {
        if (variant.title == mattressVariant.title) return variant.title;
        if (variant.title == 'Default Title') return variant.title;
        if (mattressVariant.title == 'Small Double' && variant.title == 'Double') {
          smallDouble = true;
          return variant.title;
        }
        // return variant.title == mattressVariant.title || variant.title == 'Default Title'
      });
      if (!upsellVariant) {
        item.parentNode.classList.add('hidden');
        // if(mattressUpsellSection.querySelector('.separator') && !mattressUpsellSection.querySelector('.separator').classList.contains('hidden'))
      } else {
        const addBtn = item.querySelector('.upsell-add');
        let compareAtPrice = upsellVariant.compare_at_price || upsellVariant.price;
        let price = upsellVariant.price;

        const financingMessage = item.querySelector('.upsell-financing-value');

        if (price) {
          item.querySelector('.price').dataset.variant = mattressVariant.title;
          item.querySelector('.js-calc__installment').dataset.variant = mattressVariant.title;
          item.querySelector('.js-calc__modal').dataset.variant = mattressVariant.title;
          if (financingMessage) {
            financingMessage.innerHTML = window.renderPrice(
              price / financingMessage.dataset.installments
            );
          }
        }
        item.parentNode.classList.remove('hidden');
        addBtn.dataset.price = price;
        addBtn.dataset.compare_at_price = compareAtPrice;
        addBtn.dataset.ids = upsellVariant.id;

        if (window.tempCouponSettings) {
          if (window.tempCouponSettings.updatePricesOnSite) {
            window.tempCouponSettings.updatePricesOnSite();
          }
          if (window.tempCouponSettings.updateModalsOnSite) {
            window.tempCouponSettings.updateModalsOnSite();
          }
          if (window.tempCouponSettings.updateInstallmentsOnSite) {
            window.tempCouponSettings.updateInstallmentsOnSite();
          }
          if (window.tempCouponSettings.updateLabelsOnSite) {
            window.tempCouponSettings.updateLabelsOnSite();
          }
        }

        crossSellSection.querySelectorAll('.trustpilot-widget').forEach(trustpilot => {
          try {
            window.Trustpilot.loadFromElement(trustpilot);
          } catch (e) {
            console.log('Trustpilot loading...');
          }
        });

        //bedding badge
        let beddingBadge = item.querySelector('.upsell-row__discount-badge');
        if (beddingBadge) {
          let percentDiscount = 100 - (price * 100) / compareAtPrice;
          if (percentDiscount > 0) {
            beddingBadge.innerText = `${Math.floor(percentDiscount)}% OFF`;
          }
        }
      }
    });
  }
}

function renderAllBundles(
  suggestedBundlesContainer,
  variant,
  variant_title,
  mattress_type,
  product_name
) {
  document.querySelector('.suggested__bundles').classList.remove('hidden');
  const bundlesContentWrap = document.querySelector('.bundle-content-wrap');
  const productsData = JSON.parse(document.getElementById('products-metafileds-data').textContent);
  const new_product_item = document.querySelectorAll('.bundle__item');
  const loading_spinner = document.querySelector(
    '.suggested__bundles .MuiCircularProgress-colorPrimary'
  );
  let mattresses_variant_ids = [];
  let variant_id = variant;
  let current_variant_title = variant_title;
  loading_spinner.style.display = 'flex';

  if (bundlesContentWrap === null) {
    window.waitForBundles().then(data => {
      let bundle_ids = [];
      let bundle_product_ids = [];
      let suggested_poducts = [];

      //Getting mattresses_variant_ids
      Object.keys(productsData.mattresses).forEach(key => {
        if (productsData.mattresses[key].handle.includes(mattress_type)) {
          for (let v of productsData.mattresses[key].variants) {
            mattresses_variant_ids.push(v.id);
          }
        }
      });

      //Getting bundle_ids in which current product is included
      for (let bundle_product of data) {
        let variants = bundle_product.products;
        //To include THE NECTAR BEDDING BUNDLE on each DUVET PROTECTOR BEDDING SET
        if (
          bundle_product.name.includes(`Bedding Bundle ${current_variant_title}`) &&
          product_name.includes('DUVET')
        ) {
          bundle_ids.push(bundle_product.id);
        }
        if (
          bundle_product.name.includes(`Bedding Bundle ${current_variant_title}`) &&
          product_name.includes('PROTECTOR')
        ) {
          bundle_ids.push(bundle_product.id);
        }
        if (
          bundle_product.name.includes(`Bedding Bundle ${current_variant_title}`) &&
          product_name.includes('BEDDING SET')
        ) {
          bundle_ids.push(bundle_product.id);
        }
        //Looking for bundle which have selected mattress type && current variant id
        if (!bundle_product.name.toLowerCase().includes('gwp')) {
          if (variants.hasOwnProperty(variant_id)) {
            for (let v of mattresses_variant_ids) {
              if (variants.hasOwnProperty(v)) {
                // Bundle products id
                bundle_ids.push(bundle_product.id);
              }
            }
          }
        }
      }

      // console.log(bundle_ids)
      //If no bundles found
      if (bundle_ids.length == 0) {
        document.querySelector('.suggested__bundles').classList.add('hidden');
        document.querySelector('.mattress-radios').classList.add('hidden');
      }

      //Getting all bundle products and checking if it contains bundle_id
      Object.keys(productsData.bundlesMetafields).forEach(key => {
        //Getting full info about all bundle in 1 string
        bundle_product_ids.push(`${key} : ${JSON.stringify(productsData.bundlesMetafields[key])}`);
      });
      for (let bundle_id of bundle_ids) {
        for (let bundle_product_id of bundle_product_ids) {
          if (bundle_product_id.includes(`${bundle_id}`)) {
            suggested_poducts.push(`${bundle_product_id.split(':')[0]}+${bundle_id}`);
          }
        }
      }

      //removing duplicates if exist
      function removeDuplicates(data) {
        return data.filter((value, index) => data.indexOf(value) === index);
      }

      //remove all other bundle items, heading and spinner
      new_product_item.forEach(product_old_item => {
        product_old_item.remove();
      });
      document.querySelectorAll('.suggested__bundles h4').forEach(h4 => h4.remove());
      loading_spinner.style.display = 'none';
      let total_price;
      let total_compare_price;
      let total_savings = [];
      let i = 0;

      //rendering each product
      removeDuplicates(suggested_poducts).forEach(function (product_id, idx, array) {
        let handle = product_id.split('+')[0].replace(' ', '');
        Object.keys(productsData.products_info).forEach(key => {
          if (key == handle) {
            let product = productsData.products_info[key];
            let product_title = product.title
              .replace('THE NECTAR', '')
              .replace('Nectar', '')
              .replace(' ', '');
            let product_img_src = product.featured_image;
            let bundle_variant = product.variants.filter(
              variant => variant.title == current_variant_title
            );
            let bundle_variant_id = product_id.split('+')[1];
            let available = bundle_variant[0].available;
            let variant_price = bundle_variant[0].price;
            let variant_compare_price = bundle_variant[0].compare_at_price;
            total_price = parseFloat(variant_price);
            total_compare_price = parseFloat(variant_compare_price);
            total_savings.push((total_compare_price - total_price) / 100);
            if (available) {
              let product_item = `
                          <div class="bundle__item hidden" data-sorting='${variant_price}' data-title='${product_title}' data-bundle='${bundle_variant_id}'>
                            <div class="item__img">
                              <img src="${product_img_src}" alt="">
                            </div>
                            <div class="item__info">
                              <modal-opener class="product-popup-modal__opener no-js-hidden" data-modal="#PopupModal-product-description">
                                <button class="info-title link" type="button" data-size="${current_variant_title}" data-url="/products/${handle}" aria-haspopup="dialog">${product_title}</button>
                              </modal-opener>
                              <div class="price coupon-price">
                                ${window.renderPrice(variant_price, variant_compare_price)}
                              </div>
                            </div>
                            <div class="button add_bundle" onclick='addBundleToCart(${bundle_variant_id}, 1, () => location.href = "/cart/")'>Add</div>
                            </div>
                `;
              i++;

              suggestedBundlesContainer.insertAdjacentHTML('beforeend', product_item);
              if (i == array.length) {
                let discount_price = Math.max(...total_savings);
                suggestedBundlesContainer.insertAdjacentHTML(
                  'afterbegin',
                  `<h4>Save up to <span class="saved_amount">£${discount_price.toFixed(2)}</span> with Nectar Bundle</h4>`
                );
                //show radio buttons
                document.querySelector('.mattress-radios').classList.remove('hidden');
              }
            }
          }
        });
      });

      //sort by price
      function comparator(a, b) {
        if (parseInt(a.dataset.sorting) > parseInt(b.dataset.sorting)) return 1;
        if (parseInt(a.dataset.sorting) < parseInt(b.dataset.sorting)) return -1;
        return 0;
      }

      // Function to sort Data
      function SortData() {
        var indexes = document.querySelectorAll('[data-sorting]');
        var indexesArray = Array.from(indexes);
        let sorted = indexesArray.sort(comparator);
        sorted.forEach(e => {
          e.classList.remove('hidden');
          suggestedBundlesContainer.appendChild(e);
        });
      }
      SortData();
    });
  }
}

function renderBundlesContent(wrapper, products, bundle, size) {
  let GWP = false;
  let SINGLEGIFT = false;

  let fullDiscountGWP = 0;
  if (
    bundle.name.toLowerCase().includes('gwp') ||
    bundle.name.toLowerCase().includes('gift') ||
    window.location.pathname.includes('memory-foam-mattress') ||
    window.location.pathname.includes('hybrid-mattress')
  ) {
    GWP = true;
  }
  if (window.location.pathname.includes('aff') || window.location.pathname.includes('outdated')) {
    GWP = false;
  }
  let productsArray = products
    .sort((a, b) => b.price - a.price)
    .filter(el => {
      // if(el.handle === 'memory-foam-mattress' || el.handle === 'hybrid-mattress' || el.handle.includes('premier-mattress') ) return false
      // if(el.handle === 'hybrid-mattress') return false
      if (GWP && el.handle.includes('premier-mattress')) return false;
      return true;
    });

  if (productsArray.length <= 1) {
    SINGLEGIFT = true;
  }

  const html = productsArray.map(product => {
    let productBundler = {};
    let productVariant;
    let pillow = false;

    if (GWP && product.title.toLowerCase().includes('+ 2 premium pillows')) {
      product = JSON.parse(document.querySelector('.pillow-object').innerText);
      pillow = true;
      productBundler.discount_amount = 999;
      productVariant = product;
      if (bundle.name.toLowerCase().includes('single')) {
        productVariant.title = productVariant.title.replace(/ \(pair\)/gim, '');
      }
    } else {
      productBundler = Object.values(bundle.products).find(prod => prod.handle == product.handle);
      if (bundle.product_level == 'variant') {
        productVariant = product.variants.find(variant => variant.id == productBundler.id);
      } else if (bundle.product_level == 'product') {
        productVariant = product.variants
          .reverse()
          .find(v => v.title == size || v.title == 'Default Title' || size.includes(v.title));
      }
    }
    let title = product.title.toLowerCase();
    let featuredImage = product.images[0];

    if (GWP && size == 'Single' && title.includes('pillow')) {
      featuredImage =
        'https://cdn.shopify.com/s/files/1/0254/6309/5342/files/single-pillow.png?v=1638180265';
    }

    //remove (pair) on pillow product in single bundles
    // if(product.handle === "premium-foam-pillow" && bundle.name.toLowerCase().includes('single')){
    //   title = title.replace('(pair)', '')
    // }

    if (productVariant.title == 'Single') {
      title = title.replace('2 premium pillows', 'premium pillow');
    }

    const originalPrice = productVariant.compare_at_price || productVariant.price;
    if (GWP) fullDiscountGWP += originalPrice;
    let price = calcPrice(
      productVariant.price,
      productBundler.discount_amount,
      bundle.discount_type,
      bundle.percentage_value
    );
    if (price < 0) price = 0;
    return `
      <div class="product-item" data-variant_id=${productVariant.id}>
        <div class="subproduct-image" style="background-image: url(${featuredImage});"></div>

        <modal-opener class="product-popup-modal__opener no-js-hidden" data-modal="#PopupModal-product-description">
          <button class="subproduct-title link" type="button" data-size="${pillow ? 'Default Title' : productVariant.title}" data-price="${price}" data-url="/products/${product.handle}" aria-haspopup="dialog">${title.replace(/the nectar/gim, '').replace(/nectar /gim, '')}</button>
        </modal-opener>

        <div class="subproduct-size">${size == 'Small Double' && !productVariant.title.toLowerCase().includes('pillow') && !productVariant.title.toLowerCase().includes('default') && !SINGLEGIFT ? '*' + productVariant.title : ''}</div>
        <div class="price subproduct-price">
          ${window.renderPrice(price, originalPrice)}
        </div>
      </div>
    `;
  });
  if (size == 'Small Double' && !SINGLEGIFT) {
    html.push('<div class="size-note">*Duvet and Sheet Set Are Double, Not Small Double</div>');
  }
  if (GWP && !SINGLEGIFT) {
    html.unshift(`
      <div class="bundle-content__gwp-offer">
        <svg class="icon icon-checkmark" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"/>
        </svg>
        <p><span class="bundle-content__gwp-discount">£${fullDiscountGWP % 100 == 0 ? fullDiscountGWP / 100 : (fullDiscountGWP / 100).toFixed(2)}</span> Of Accessories Included!</p>
      </div>
    `);
  }

  // if(SINGLEGIFT){
  //   wrapper.classList.add('single-gift-wrap')
  //   html.unshift(`
  //     <span class="single-gift-wrap__free-badge">
  //       FREE
  //     </span>
  //   `)

  // }

  wrapper.innerHTML = html.join(' ');
}

function calcPrice(price, discount, discountType, percent) {
  switch (discountType) {
    case 'products_discounts': {
      return price - discount * 100;
    }
    case 'percentage': {
      return price * (1 - percent / 100);
    }
    default: {
      return price;
    }
  }
}
function fetchProductsLoop(array) {
  const promiseArray = array.map(product => {
    return fetch(`/products/${product}.js`).then(function (response) {
      return response.json();
    });
  });

  return Promise.all(promiseArray);
}

window.renderPrice = function (discountedPrice, originalPrice, round = 2, state, label) {
  let price =
    discountedPrice % 100 == 0 ? discountedPrice / 100 : (discountedPrice / 100).toFixed(round);
  let sale;
  price > 0
    ? (sale = `<ins ${state ? 'price' : 'sale_price'}>£${price}</ins>`)
    : (sale = `<ins class="free">Included </ins><ins>£${price} </ins>`);

  let orginal;
  if (originalPrice) {
    orginal = originalPrice % 100 == 0 ? originalPrice / 100 : (originalPrice / 100).toFixed(2);
  }
  const rrp = orginal && orginal != discountedPrice ? `<del price>£${orginal}</del>` : '';
  const saving =
    orginal && orginal != discountedPrice
      ? `<span class="save-badge">Save £${orginal - price}</span>`
      : ``;
  return price == orginal ? sale : rrp + sale;
};

window.formatPrice = function (price) {
  const formattedPrice = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(price);

  const decimalIndex = formattedPrice.indexOf('.');
  if (decimalIndex !== -1) {
    const decimalPart = formattedPrice.slice(decimalIndex + 1);
    if (decimalPart.length === 1) {
      return formattedPrice + '0';
    }
  }

  return formattedPrice.replace(/\.00$/, '');
};

window.addBundleToCart = function (id, qtt, callback, size) {
  window.waitForBundles().then(bundles => {
    const bundle = bundles.find(bundle => bundle.id == id);
    let updates = {};
    let productFetch;
    let productsArray;
    productsArray = Object.values(bundle.products).sort(
      (a, b) => a.discount_amount - b.discount_amount
    );
    if (bundle.product_level == 'variant') {
      productsArray.forEach(product => {
        const variant = Object.values(product.variants)[0];
        updates[variant.id] = qtt ? variant.quantity * qtt : variant.quantity;
      });
    } else if (bundle.product_level == 'product' && size) {
      productFetch = function () {
        return new Promise((resolve, reject) => {
          fetchProductsLoop(productsArray.map(p => p.handle)).then(data => {
            data.forEach(productData => {
              let selectedVariant = productData.variants
                .reverse()
                .find(
                  variantData =>
                    variantData.title === size ||
                    variantData.title === 'Default Title' ||
                    size.includes(variantData.title)
                );
              updates[selectedVariant.id] = qtt ? qtt : 1;
            });
            resolve();
          });
        });
      };
    }
    if (productFetch) {
      productFetch().then(() => {
        fetch('/cart/clear/').then(() => {
          window.updateCart(updates, callback);
        });
      });
    } else {
      fetch('/cart/clear/').then(() => {
        window.updateCart(updates, callback);
      });
    }
  });
};

window.updateCart = function (updates, callback) {
  if (typeof liquidAjaxCart === 'object') {
    const body = {
      updates
    };
    const options = {
      lastCallback: function (requestState) {
        callback;
      },
      info: {
        addToCart: true
      },
      important: true
    };
    liquidAjaxCart.update(body, options);
  } else {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
      .then(response => response.json())
      .then(data => {
        callback(data);
      });
  }
};

window.waitForBundles = function () {
  return new Promise((resolve, reject) => {
    if (window.bundles) {
      resolve(window.bundles);
    }
    const interval = setInterval(() => {
      try {
        window.bundles = window.bundles || window.bndlr.getBundles();
      } catch (e) {
        console.log('Waiting for bundles...');
      }
      if (window.bundles) {
        clearInterval(interval);
        resolve(window.bundles);
      }
    }, 1000);
  });
};

window.waitForNibble = function () {
  return new Promise((resolve, reject) => {
    // Check immediately if the condition is met to avoid waiting for the interval unnecessarily
    if (window.NibbleShopifyData) {
      resolve();
      return; // Exit the function early if the condition is already true
    }
    const interval = setInterval(() => {
      if (window.NibbleShopifyData) {
        clearInterval(interval);
        resolve();
      } else {
        console.log('Waiting for Nibble app...');
      }
    }, 1000);
  });
};

// window.updateDivideBuy = function (price) {
//   return new Promise((resolve, reject) => {
//     const intervalDividebuy = setInterval(() => {
//       let counter = 0;
//       try{
//         if(counter > 30) clearInterval(intervalDividebuy);
//         window.displayTooltip(price/100, window.instalments);
//         clearInterval(intervalDividebuy);
//         resolve();
//       }
//       catch(e){
//         counter++;
//       }
//     }, 500);
//   });
// }

window.isSupportAvailable = function (timeString) {
  const daysMap = {
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
    Sunday: 0
  };
  const currentTimeDate = new Date();
  const currentTime = new Date(
    currentTimeDate.toLocaleString('en-US', { timeZone: 'Europe/London' })
  );

  const currentDay = currentTime.getDay();
  const currentDate = `${String(currentTime.getDate()).padStart(2, '0')}-${String(currentTime.getMonth() + 1).padStart(2, '0')}`; // "day-month" format
  const currentHours = currentTime.getHours();
  const currentMinutes = currentTime.getMinutes();
  // Separate operational and closed parts
  const [operationalHours, closedInfo] = timeString.split('<br>');
  const [days, times] = operationalHours.split(' ');
  const [startTime, endTime] = times.split('-').map(time => {
    const [hour, minute] = time.replace(/(am|pm)/, '').split('.');
    return (
      parseInt(hour) +
      (time.includes('pm') && parseInt(hour) < 12 ? 12 : 0) +
      (minute ? parseInt(minute) / 60 : 0)
    );
  });
  const [startDay, endDay] = days.split('-').map(day => daysMap[day]);

  // Check closed days
  if (closedInfo) {
    const closedDates = closedInfo
      .replace('Closed: ', '')
      .split(', ')
      .map(date => {
        const [day, monthName] = date.split(' of ');
        const dayNumber = day.replace('th', ''); // Remove 'th' from day
        const month = new Date(`${monthName} 1 2000`).getMonth() + 1; // Convert month name to month number
        return `${String(dayNumber).padStart(2, '0')}-${String(month).padStart(2, '0')}`;
      });
    if (closedDates.includes(currentDate)) {
      return false; // Closed today
    }
  }

  // Check if today is within the range of days
  if (currentDay >= startDay && currentDay <= endDay) {
    const currentDecimalTime = currentHours + currentMinutes / 60;
    return currentDecimalTime >= startTime && currentDecimalTime < endTime;
  }

  return false;
};

// window.waitForKlaviyo = function () {
//   return new Promise((resolve, reject) => {
//     if (window.klaviyoModulesObject) {
//       resolve(window.klaviyoModulesObject);
//     };
//     const interval = setInterval(() => {
//       try{
//         window.klaviyoModulesObject
//       }
//       catch(e){
//         console.log('Waiting for Klaviyo...');
//       }
//       if (window.klaviyoModulesObject) {
//         clearInterval(interval);
//         resolve(window.klaviyoModulesObject);
//       };
//     }, 1000);
//   });
// }

window.scrollToCustom = function (to, id) {
  var smoothScrollFeature = 'scrollBehavior' in document.documentElement.style;
  // var articles = document.querySelectorAll("ul#content > li"), i;
  if (to == 'elem') to = document.querySelector(id).offsetTop - 200;
  var i = parseInt(window.pageYOffset);
  if (i != to) {
    if (!smoothScrollFeature) {
      to = parseInt(to);
      if (i < to) {
        var int = setInterval(function () {
          if (i > to - 20) i += 1;
          else if (i > to - 40) i += 3;
          else if (i > to - 80) i += 8;
          else if (i > to - 160) i += 18;
          else if (i > to - 200) i += 24;
          else if (i > to - 300) i += 40;
          else i += 60;
          window.scroll(0, i);
          if (i >= to) clearInterval(int);
        }, 15);
      } else {
        var int = setInterval(function () {
          if (i < to + 20) i -= 1;
          else if (i < to + 40) i -= 3;
          else if (i < to + 80) i -= 8;
          else if (i < to + 160) i -= 18;
          else if (i < to + 200) i -= 24;
          else if (i < to + 300) i -= 40;
          else i -= 60;
          window.scroll(0, i);
          if (i <= to) clearInterval(int);
        }, 15);
      }
    } else {
      window.scroll({
        top: to,
        left: 0,
        behavior: 'smooth'
      });
    }
  }
};

window.makeRequest = function (method, url) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        resolve(xhr.response);
      } else {
        reject({
          status: this.status,
          statusText: xhr.statusText
        });
      }
    };
    xhr.onerror = function () {
      reject({
        status: this.status,
        statusText: xhr.statusText
      });
    };
    xhr.send();
  });
};

let hideConvertflow = function () {
  let utmSource;
  try {
    utmSource = decodeURIComponent(getUrlParameter('utm_source'));
  } catch (e) {
    console.error('Check UTM URL');
  }

  let hideFunc = () => {
    let styleEl = document.createElement('style');
    document.head.appendChild(styleEl);
    let styleSheet = styleEl.sheet;
    //console.log(styleSheet)
    styleSheet.insertRule('.convertflow-cta.cf-overlay { display:none !important; }', 0);
    console.log('Convertflow hidden.');
  };

  if (
    (window.coupons?.applied && window.coupons?.applied.title.endsWith('45A')) ||
    (window.coupons?.applied && window.coupons?.applied.title.endsWith('45B')) ||
    (window.coupons?.applied && window.coupons?.applied.title.endsWith('45C'))
  ) {
    hideFunc();
  }
  if (utmSource && utmSource.includes('bluemarketmedia')) {
    hideFunc();
  }
};
document.addEventListener('DOMContentLoaded', () => {
  hideConvertflow();
});

class DivanBedUpsell {
  constructor() {
    waitForBundles().then(() => {
      this.initAll();
    });
  }

  initAll() {
    this.updateVariables();
    if (this.upsellPopup && this.upsellBlock) {
      this.updateFunctions();
    }
  }

  updateVariables() {
    this.upsellPopup = document.querySelector('.upsell-block__divan-popup');
    this.upsellBlock = document.querySelector('.upsell-item.item__divan-bed');

    if (this.upsellPopup && this.upsellBlock) {
      this.upsellOverlay = document.querySelector('.upsell-block__divan-popup--overlay');
      this.size = Array.from(document.querySelectorAll('.dropdown-modal input')).find(
        radio => radio.checked
      )?.dataset.variant_title;
      this.divanBedButton = this.upsellBlock.querySelector('.divan-bed__popup-button');
      this.checked = this.upsellPopup.querySelector(
        '.bedframe-selector_product input:checked'
      )?.value;
      this.product = this.upsellPopup.querySelector(
        `.divan-popup__wrapper[data-product_id=${this.checked}]`
      );
      this.upsellAddButton = this.upsellPopup.querySelector('.divan-bed__popup-add');
      this.upsellClose = this.upsellPopup.querySelector('.upsell-block__divan-popup--close');
      this.optionWrappers = this.upsellPopup.querySelectorAll(
        '.bedframe-selector__wrapper:not(.bedframe-selector_product)'
      );
      this.productWrappers = this.upsellPopup.querySelectorAll('.bedframe-selector_product');
      this.sizeUpdatedByCustomer = false;
      // this.divanAdded = false;
    }

    this.divanBedButtonHandler();
  }

  updateFunctions() {
    this.updateAccordions();
    this.initSlider();
    this.switchSelected();
    this.bindEvents();
    this.updateSize();
    this.onVariantChange();
  }

  bindEvents() {
    this.divanBedButtonHandler();

    this.upsellAddButton.addEventListener('click', e => {
      e.preventDefault();
      if (document.querySelector('.divan-bed__popup-button.added')) {
        this.removeDivanFromCart();
      } else {
        this.addDivanToCart();
      }
    });

    this.upsellClose.addEventListener('click', e => {
      e.preventDefault();
      this.closeDivanBedPopup();
    });

    this.optionWrappers.forEach(optionWrapper => {
      let input = optionWrapper.querySelector('input');
      input.addEventListener('change', () => this.onVariantChange());
    });

    this.productWrappers.forEach(productWrapper => {
      let input = productWrapper.querySelector('input');
      input.addEventListener('change', e => this.onProductChange(e.target));
    });

    this.upsellPopup.querySelectorAll('fieldset[data-option="size"] input').forEach(size =>
      size.addEventListener('change', () => {
        this.sizeUpdatedByCustomer = true;
      })
    );

    this.upsellOverlay.addEventListener('click', e => {
      e.preventDefault();
      if (e.target != this.upsellPopup) {
        this.closeDivanBedPopup();
      }
    });

    if (this.upsellBlock) {
      this.handleOpeners();
    }
  }

  handleOpeners() {
    if (this.upsellBlock) {
      let openers = [
        this.upsellBlock.querySelector('.info-title.link'),
        this.upsellBlock.querySelector('.upsell-title'),
        this.upsellBlock.querySelector('.image')
      ];
      openers.forEach(elem => {
        if (elem) {
          elem.addEventListener('click', e => {
            e.preventDefault();
            this.showDivanBedPopup();
          });
        }
      });
    }
  }

  divanBedButtonHandler() {
    if (this.divanBedButton) {
      this.divanBedButton.addEventListener('click', e => {
        e.preventDefault();
        this.showDivanBedPopup();
      });
    }
  }
  // Product change

  onProductChange(wrapper) {
    this.product = this.upsellPopup.querySelector(
      `.divan-popup__wrapper[data-product_id=${wrapper.value}]`
    );
    this.upsellAddButton.dataset.product_id = wrapper.value;
    this.switchProducts();
    this.switchSelected();
    this.updateAccordions();
    this.initSlider();
    this.onVariantChange();
    // this.updateSize();
  }

  switchSelected() {
    const fieldsets = Array.from(this.product.querySelectorAll('fieldset:not(.hidden)'));
    fieldsets.map((fieldset, index) => {
      Array.from(fieldset.querySelectorAll('input'))[0].checked = true;
    });
  }

  switchProducts() {
    this.upsellPopup.querySelectorAll('.divan-popup__wrapper').forEach(el => {
      if (
        el.dataset.product_id == this.product.dataset.product_id &&
        el.classList.contains('hidden')
      ) {
        el.classList.remove('hidden');
      } else if (
        el.dataset.product_id != this.product.dataset.product_id &&
        !el.classList.contains('hidden')
      ) {
        el.classList.add('hidden');
      }
    });
  }

  // Variant change

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateRadios();
    this.removeDivanFromCart();
    this.updateMedia();
    this.updateSelected();
    this.updatePrice();
    this.updateUpsellBlock();
  }

  updateOptions() {
    const fieldsets = Array.from(this.product.querySelectorAll('fieldset:not(.hidden)'));
    this.options = fieldsets.map((fieldset, index) => {
      return Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked).value;
    });
    // let size = Array.from(document.querySelectorAll('.dropdown-modal input')).find(radio => radio.checked)?.dataset.variant_title
    // this.options.splice( 0, 0, size );
    this.upsellAddButton.dataset.variant = this.options;
  }

  updateRadios() {
    let handle = this.upsellPopup.querySelector('.bedframe-selector_product input:checked').value;
    const fieldsets = Array.from(
      this.upsellPopup.querySelectorAll(
        `.divan-popup__wrapper[data-product_id="${handle}"] fieldset`
      )
    );
    this.options.map((option, index) => {
      if (fieldsets[index]) {
        Array.from(fieldsets[index].querySelectorAll('input')).map(radio => {
          let variations = Array.from(this.options);
          variations[index] = radio.value;
          let potential = this.getVariantData().find(variant => {
            return !variant.options
              .map((optionV, idx) => {
                return variations[idx] === optionV;
              })
              .includes(false);
          });
          if (!potential || potential.available == false) {
            if (!radio.checked && !radio.parentNode.classList.contains('hidden')) {
              radio.disabled = true;
              radio.parentNode.classList.add('hidden');
            }
          } else {
            if (radio.parentNode.classList.contains('hidden')) {
              radio.disabled = false;
              radio.parentNode.classList.remove('hidden');
            }
          }
        });
      }
    });
    window.Collapses.map((collapse, index) => {
      if (collapse.element.classList.contains('bedframe-collapse')) {
        collapse.recalculate();
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    this.divanBedButton.dataset.ids = this.currentVariant.id;
  }

  getVariantData() {
    this.variantData = JSON.parse(this.product.querySelector('.js-product-variants').textContent);
    return this.variantData;
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    let gallery = this.product.querySelector('.upsell-swiper');
    if (gallery) {
      let variantImage = gallery.querySelector(
        `.swiper-slide[data-id='${this.currentVariant.id}']`
      );
      let index = +variantImage.getAttribute('aria-label')?.split('/')[0].replace(/ /g, '');
      if (index) {
        this.upsellSwiper.slideTo(index - 1);
      }
    }
  }

  updateSize() {
    this.size = Array.from(document.querySelectorAll('.dropdown-modal input')).find(
      radio => radio.checked
    )?.dataset.variant_title;
    const fieldsets = this.product.querySelectorAll(
      '.bedframe-selector__container fieldset[data-option="size"]'
    );
    fieldsets.forEach(fieldset => {
      let input = fieldset.querySelector(
        `.bedframe-selector__wrapper:not(.hidden) input[value="${this.size}"]`
      );
      if (input) input.checked = true;
    });
  }

  updateSelected() {
    const tabs = Array.from(document.querySelectorAll('.collapse__heading'));
    tabs.forEach(tab => {
      let selectedTitle = tab.querySelector('.collapse__selected');
      if (selectedTitle && tab.nextElementSibling.querySelector('input:checked')) {
        selectedTitle.innerHTML = tab.nextElementSibling
          .querySelector('input:checked')
          .value.replaceAll('-', ' ');
      }
    });
  }

  updatePrice() {
    let variantPrice, variantComparePrice;
    console.error('runs', this.currentVariant);
    if (this.currentVariant) {
      variantPrice = this.currentVariant.price;
      variantComparePrice = this.currentVariant.compare_at_price;

      Array.from(this.upsellPopup.querySelectorAll('[data-total-value-price]')).forEach(el => {
        let totalValueInfo = JSON.parse(
          document.querySelector(`[data-total-value-popup]`).innerHTML
        );
        let totalValueVariant = totalValueInfo.find(
          variant => variant.id == this.currentVariant.id
        );
        if (totalValueVariant && totalValueVariant.value > 0) {
          el.innerHTML =
            window.cartStrings.totalValue +
            ': ' +
            renderPrice(totalValueVariant.value) +
            `<span class="total-value-tooltip-icon" data-total-value-tooltip="${totalValueVariant.handle}|${totalValueVariant.id}">i</span>`;
        } else {
          el.innerHTML = '';
        }
      });

      Array.from(this.upsellPopup.querySelectorAll('[data-total-value-saving]')).forEach(el => {
        let totalValueInfo = JSON.parse(
          document.querySelector(`[data-total-value-popup]`).innerHTML
        );
        let totalValueVariant = totalValueInfo.find(
          variant => variant.id == this.currentVariant.id
        );
        if (totalValueVariant && totalValueVariant.value > 0) {
          let diff = totalValueVariant.value - this.currentVariant.price;
          el.innerHTML = 'Save ' + renderPrice(diff);
          el.style.display = 'inline-flex';
        } else {
          el.innerHTML = '';
          el.style.display = 'none';
        }
      });
    } else if (this.divanBedButton) {
      variantPrice = this.divanBedButton.dataset.price;
      variantComparePrice = this.divanBedButton.dataset.compare_at_price;
    }

    if (this.divanBedButton) {
      this.divanBedButton.dataset.price = variantPrice;
      this.divanBedButton.dataset.compare_at_price = variantComparePrice;
    }
    if (this.upsellPopup) {
      Array.from(this.upsellPopup.querySelectorAll('.price')).forEach(el => {
        el.innerHTML = renderPrice(variantPrice, variantComparePrice);
      });
      let financing = this.upsellPopup.querySelectorAll('.divan-bed__financing-value');
      financing.forEach(
        elem => (elem.innerText = (+variantPrice / +elem.dataset.installments / 100).toFixed(2))
      );
    }
    if (this.upsellBlock) {
      let badge = this.upsellBlock.querySelector('.upsell-block__badge');
      if (badge) {
        if (variantComparePrice) {
          let percentDiscount = 100 - (variantPrice * 100) / variantComparePrice;
          badge.innerText = `${Math.floor(percentDiscount)}% OFF`;
        } else {
          badge.innerText = '';
        }
      }
    }
    if (window.recalculateTotal) {
      window.recalculateTotal();
    }
  }

  updateUpsellBlock() {
    if (
      document.querySelector('.upsell-button.divan-bed__popup-button').classList.contains('added')
    ) {
      let title = document.querySelector(
        '.upsell-item.item__divan-bed div.product-popup-modal__opener .info-title.link'
      );
      let price = document.querySelector('.upsell-item.item__divan-bed .price');
      let financing = document.querySelector(
        '.upsell-item.item__divan-bed .upsell-financing-value'
      );
      let description = document.querySelector(
        '.upsell-item.item__divan-bed .upsell__short-description'
      );
      let image = document.querySelector('.upsell-item.item__divan-bed .image img');
      let secondDescription = document.querySelector(
        '.upsell-item.item__divan-bed .frames__description'
      );

      title.innerText = this.currentVariant.name.split(' - ')[0].toLowerCase();
      price.innerHTML = renderPrice(
        this.currentVariant.price,
        this.currentVariant.compare_at_price
      );
      financing.innerText = (
        +this.currentVariant.price /
        +financing.dataset.installments /
        100
      ).toFixed(2);
      // const fieldsets = Array.from(this.product.querySelectorAll('fieldset'));
      // description.innerHTML = `
      //   ${(function loop() {
      //     this.currentVariant.options.forEach(option, index => {
      //       return `
      //         <div data-option="${fieldsets[index].dataset.option}" class="product-option">
      //           <dt class="upsell__short-description" style="text-transform:capitalize;">${fieldsets[index].dataset.option}: </dt>
      //           <dd class="upsell__short-description">${option.name}</dd>
      //         </div>
      //       `
      //     })
      //   })()}
      // `
      description.innerText = this.currentVariant.title;
      secondDescription.innerText = this.currentVariant.title;

      // let imgPath = this.currentVariant.featured_image.src.split('.')
      let src = this.currentVariant.featured_image.src.replace(
        /(\.jpeg|\.jpg|\.pjpeg|\.png|\.gif|\.heic|\.webp|\.avif)(?=\?v=)/i,
        '_500x$1'
      );
      image.dataset.src = src;
      image.src = src;
    }
  }
  // Adding to Cart

  addDivanToCart() {
    setTimeout(() => {
      this.closeDivanBedPopup();
    }, 500);
    if (window.recalculateTotal) {
      window.recalculateTotal();
    }
    this.updateAddButton(true);
    this.updateUpsellBlock();
  }

  removeDivanFromCart() {
    this.updateAddButton(false);
    if (window.recalculateTotal) {
      window.recalculateTotal();
    }
  }

  // UI Methods

  initSlider() {
    let swiperContainer = this.product.querySelector('.upsell-swiper');
    this.upsellSwiper = swiperContainer.swiper;
  }

  closeDivanBedPopup() {
    if (this.upsellPopup.classList.contains('visible'))
      this.upsellPopup.classList.remove('visible');
    if (this.upsellOverlay.classList.contains('visible'))
      this.upsellOverlay.classList.remove('visible');
    if (document.querySelector('body').classList.contains('overflow-hidden'))
      document.querySelector('body').classList.remove('overflow-hidden');
  }

  showDivanBedPopup() {
    if (!this.upsellPopup.classList.contains('visible')) this.upsellPopup.classList.add('visible');
    if (!this.upsellOverlay.classList.contains('visible'))
      this.upsellOverlay.classList.add('visible');
    if (!document.querySelector('body').classList.contains('overflow-hidden'))
      document.querySelector('body').classList.add('overflow-hidden');
    this.updateAccordions();
  }

  updateAddButton(state) {
    if (this.divanBedButton && this.currentVariant && !this.divanBedButton.dataset.ids) {
      this.divanBedButton.dataset.ids = this.currentVariant.id;
    }
    if (state == true) {
      if (!document.querySelector('.divan-bed__popup-add').classList.contains('added')) {
        document.querySelector('.divan-bed__popup-add').classList.add('added');
      }
      document.querySelector('.divan-bed__popup-add').innerText = 'ADDED';
      if (
        !document
          .querySelector('.upsell-button.divan-bed__popup-button')
          .classList.contains('added')
      ) {
        document.querySelector('.upsell-button.divan-bed__popup-button').classList.add('added');
      }
      let bedframeButton = document.querySelector('.item__bedframe .upsell-button.added');
      if (bedframeButton) {
        bedframeButton.classList.remove('added');
      }

      let bedframePopupButton = document.querySelector('.bedframe__popup-add.added');
      if (bedframePopupButton) {
        bedframePopupButton.classList.remove('added');
        bedframePopupButton.innerText = 'ADD';
      }
    } else {
      if (
        document.querySelector('.divan-bed__popup-add') &&
        document.querySelector('.divan-bed__popup-add').classList.contains('added')
      ) {
        document.querySelector('.divan-bed__popup-add').classList.remove('added');
      }
      if (document.querySelector('.divan-bed__popup-add')) {
        document.querySelector('.divan-bed__popup-add').innerText = 'ADD';
      }
      if (
        document.querySelector('.upsell-button.divan-bed__popup-button') &&
        document.querySelector('.upsell-button.divan-bed__popup-button').classList.contains('added')
      ) {
        document.querySelector('.upsell-button.divan-bed__popup-button').classList.remove('added');
      }
    }
  }

  checkButtons() {
    if (this.divanBedButton && this.divanBedButton.classList.contains('added')) {
      this.updateAddButton(true);
    } else {
      this.updateAddButton(false);
    }
  }

  updateAccordions() {
    this.upsellPopup.querySelectorAll('.bedframe-collapse').forEach(function (element) {
      element.collapse = Object.assign(new Collapse(element));
    });
    window.Collapses.forEach(collapse => {
      collapse.recalculate();
    });
  }
}

class BedframeUpsell {
  constructor() {
    // this.initAll()
  }

  initAll() {
    waitForBundles().then(() => {
      this.updateVariables();
      if (this.upsellPopup && this.upsellBlock) {
        this.disableEventListeners();
        this.bindEvents();
      }
    });
  }

  updateVariables() {
    this.upsellPopup = document.querySelector('.upsell-block__bedframe-popup');
    this.upsellBlock = document.querySelector('.upsell-item.item__bedframe');

    if (this.upsellPopup && this.upsellBlock) {
      this.upsellOverlay = document.querySelector('.upsell-block__divan-popup--overlay');
      this.size = Array.from(document.querySelectorAll('.dropdown-modal input')).find(
        radio => radio.checked
      )?.dataset.variant_title;
      this.bedframeButton = this.upsellBlock.querySelector(
        '.upsell-item.item__bedframe .upsell-add.upsell-button'
      );
      this.upsellAddButton = this.upsellPopup.querySelector('.bedframe__popup-add');
      this.upsellClose = this.upsellPopup.querySelector('.upsell-block__bedframe-popup--close');
    }
    this.bedframeButtonHandler();
  }

  bindEvents() {
    this.bedframeButtonHandler();

    this.upsellAddButton.addEventListener('click', e => {
      e.preventDefault();
      if (document.querySelector('.item__bedframe .upsell-button.added')) {
        this.removeDivanFromCart();
      } else {
        this.addDivanToCart();
      }
    });

    this.upsellClose.addEventListener('click', e => {
      e.preventDefault();
      this.closeDivanBedPopup();
    });

    this.upsellOverlay.addEventListener('click', e => {
      e.preventDefault();
      if (e.target != this.upsellPopup) {
        this.closeDivanBedPopup();
      }
    });

    let openers = [
      this.upsellBlock.querySelector('.upsell-title'),
      this.upsellBlock.querySelector('.image')
    ];
    openers.forEach(elem => {
      if (!elem) return;
      elem.addEventListener('click', e => {
        e.preventDefault();
        this.showDivanBedPopup();
      });
    });
  }

  bedframeButtonHandler() {
    if (!this.bedframeButton) return null;
    this.bedframeButton.addEventListener('click', e => {
      e.preventDefault();
      this.showDivanBedPopup();
    });
  }

  disableEventListeners() {
    if (!this.bedframeButton) return;
    let clone = this.bedframeButton.cloneNode(true);
    this.bedframeButton.parentNode.replaceChild(clone, this.bedframeButton);
    this.bedframeButton = this.upsellBlock.querySelector(
      '.upsell-item.item__bedframe .upsell-add.upsell-button'
    );
  }

  showDivanBedPopup() {
    if (!this.upsellPopup.classList.contains('visible')) this.upsellPopup.classList.add('visible');
    if (!this.upsellOverlay.classList.contains('visible'))
      this.upsellOverlay.classList.add('visible');
    if (!document.querySelector('body').classList.contains('overflow-hidden'))
      document.querySelector('body').classList.add('overflow-hidden');
  }

  closeDivanBedPopup() {
    if (this.upsellPopup.classList.contains('visible'))
      this.upsellPopup.classList.remove('visible');
    if (this.upsellOverlay.classList.contains('visible'))
      this.upsellOverlay.classList.remove('visible');
    if (document.querySelector('body').classList.contains('overflow-hidden'))
      document.querySelector('body').classList.remove('overflow-hidden');
  }

  checkButtons() {
    if (document.querySelector('.item__bedframe .upsell-add').classList.contains('added')) {
      this.updateAddButton(true);
    } else {
      this.updateAddButton(false);
    }
  }

  updateAddButton(state) {
    if (state == true) {
      if (!document.querySelector('.bedframe__popup-add').classList.contains('added')) {
        document.querySelector('.bedframe__popup-add').classList.add('added');
      }
      document.querySelector('.bedframe__popup-add').innerText = 'ADDED';
      if (!document.querySelector('.item__bedframe .upsell-button').classList.contains('added')) {
        document.querySelector('.item__bedframe .upsell-button').classList.add('added');
      }
      let divanBedButton = document.querySelector('.divan-bed__popup-button.added');
      if (divanBedButton) {
        divanBedButton.classList.remove('added');
      }
      let divanBedPopupButton = document.querySelector('.divan-bed__popup-add.added');
      if (divanBedPopupButton) {
        divanBedPopupButton.classList.remove('added');
        divanBedPopupButton.innerText = 'ADD';
      }
      bundlePriceUpdateWithBeds();
    } else {
      if (document.querySelector('.bedframe__popup-add').classList.contains('added')) {
        document.querySelector('.bedframe__popup-add').classList.remove('added');
      }
      document.querySelector('.bedframe__popup-add').innerText = 'ADD';
      if (document.querySelector('.item__bedframe .upsell-button').classList.contains('added')) {
        document.querySelector('.item__bedframe .upsell-button').classList.remove('added');
      }
      initStarterBundlePrice();
    }
  }

  updateDescription() {
    let description = this.upsellBlock.querySelector('.frames__description');
    let source = this.upsellBlock.querySelector('.upsell__short-description');
    description.setAttribute('style', 'display:none !important');
    source.style.display = 'block';
  }

  addDivanToCart() {
    setTimeout(() => {
      this.closeDivanBedPopup();
    }, 500);
    this.updateAddButton(true);
    this.updateDescription();
    if (window.recalculateTotal) {
      window.recalculateTotal();
    }

    if (document.querySelector('[data-bundle-builder]')) {
      let button = document.querySelector('.divan-bed__popup-add');
      console.error(button);
    }
  }

  removeDivanFromCart() {
    this.updateAddButton(false);
    if (window.recalculateTotal) {
      window.recalculateTotal();
    }
  }
}
window.bedframeUpsell = new BedframeUpsell();
